import type { Dict } from "./en";

const ru: Dict = {
  grid: {
    controls: { group: "Управление масштабом сетки", zoomIn: "Приблизить", zoomOut: "Отдалить", fit: "Вписать сетку в экран" },
    hud: { aria: "HUD координат сетки", instrument: "Панель", xy: "X · Y", zoom: "Масштаб", grid: "Сетка", chain: "Сеть" },
    legend: {
      gridZero: { label: "Grid Zero", desc: "Центральное заблокированное ядро" },
      vipCore: { label: "VIP Core", desc: "Престижное центральное кольцо · продаётся" },
      premium: { label: "Premium", desc: "Бульвары и внутреннее кольцо" },
      reserve: { label: "Резерв", desc: "4 заблокированные зарезервированные зоны" },
      standard: { label: "Standard", desc: "Обычная территория" },
    },
    loading: { initializing: "Инициализация территории" },
    mode: { aria: "Режим взаимодействия с сеткой", select: "Выделить", selectHint: "Нарисовать прямоугольник", inspect: "Осмотреть", inspectHint: "Кликайте по участкам", itemAria: "Режим {label} — {hint}" },
    enter3d: { title: "Войти в 3D", fallbackName: "территория" },
    panel: {
      parcelProfileAria: "Профиль участка", parcelProfileTitle: "Профиль участка", parcel: "Участок",
      territoryName: "Название территории", owner: "Владелец", position: "Позиция", size: "Размер", slots: "Слоты", zone: "Зона",
      claimBlock: "Блок клейма", claimTx: "Tx клейма", selectTerritory: "Выберите территорию",
      emptySelection: "В ячейке нет участка. Нажмите на любую принадлежащую территорию, чтобы увидеть её досье.",
      emptyDefault: "Нажмите на участок на сетке, чтобы увидеть владение, координаты и on-chain идентичность.",
      contextAria: "Панель контекста", panelAria: "Панель", closePanel: "Закрыть панель", snapshot: "Снимок",
      titleArtwork: "Работа", titleSelection: "Выбор", titleContext: "Контекст",
      parcelNum: "Парцель #{id}", selectionSize: "{w} × {h} · {slots} слотов", drawRectHint: "Нарисуйте прямоугольник на сетке",
    },
    context: {
      emptyTitle: "Территория не выбрана",
      emptyDesc: "Нарисуйте прямоугольник на сетке, чтобы увидеть слоты, зону, уровень редкости и цену.",
    },
    detail: {
      fetchFailed: "Не удалось загрузить детали: {error}",
      conflict: "Конфликт инварианта данных в этой ячейке: {count} парцелей перекрываются. Выбор подавлен.",
      cellOutside: "За пределами сетки ({x}, {y})",
      cellLoadingMap: "Загрузка данных карты…",
      cellConfirming: "Подтверждение ячейки ({x}, {y})…",
      cellEmpty: "Ячейка ({x}, {y}): в этой ячейке нет проиндексированного парцеля (на блоке {block})",
      cellConfirmError: "Не удалось подтвердить текущее состояние ячейки.",
      chainMismatch: "Просмотр недоступен из-за несоответствия сети.",
      indexerNotReady: "Индексатор не готов — снимка пока нет.",
      clickHint: "Нажмите на парцель, чтобы увидеть детали.",
      zoneClassifying: "Классификация…",
      zoneUnavailable: "Недоступно",
      zoneSaleLocked: "· продажа заблокирована",
      zoneMixed: "· зона смешанная",
    },
    toolbar: {
      territory: "Территория",
      scrollToZoom: "прокрутка для масштаба",
      menu: "Меню",
      openNav: "Открыть навигацию",
      hideNav: "Скрыть навигацию",
      revealAreas: "Показать зоны",
      revealAreasAria: "Показать зоны территории",
      zonesUnavailable: "Карта зон недоступна — автоматическая повторная попытка",
      zonesRetry: "Повторить",
      showDragArtwork: "Показать и перетащить работу",
      showDragArtworkAria: "Показать и перетащить работу",
      showDragArtworkTitle: "Показать мою работу на сетке и перетащить её на другой парцель",
      loading: "Загрузка…",
      myTerritories: "Мои территории",
    },
    status: {
      live: "ОНЛАЙН", cached: "КЭШ", chain: "СЕТЬ",
      liveTitle: "В сети · синхронизировано",
      cachedTitle: "Показан последний известный снимок",
      chainTitle: "Несоответствие сети — данные просмотра подавлены",
    },
    artworkMsg: {
      none: "У вас пока нет Frozen Artworks.",
      noPlaced: "Нет размещённых работ для перемещения.",
      connectWallet: "Подключите кошелёк, чтобы перемещать свои работы.",
    },
    slotCount: {
      slots: "слотов",
      selectedTitle: "{slots} слотов выбрано ({w} × {h})",
    },
    bottomSheet: { aria: "Нижняя панель", dragOpen: "Потяните, чтобы изменить размер или свернуть", handle: "Ручка панели" },
    stats: {
      networkStatus: "Статус сети", live: "В эфире", offline: "Офлайн", syncing: "Синхронизация", chain: "Сеть",
      parcelsClaimed: "Занятые участки", onChain: "on-chain", cellsAllocated: "Выделенные ячейки",
      finiteWorld: "{pct}% конечного мира", indexerHead: "Голова индексатора", finalized: "финализирован #{block}",
    },
    capacity: {
      territory: "Территория", resolving: "Определение территории…", unavailable: "Ёмкость территории недоступна",
      area: "Площадь территории", publishability: "Публикуемость", publishable: "Публикуемо",
      notPublishable: "Непубликуемо · Минимум {min} u²", gpCapacity: "Ёмкость GP", propertyUnits: "Единицы собственности",
    },
    artworks: {
      title: "Работы на этой земле", scanning: "Сканирование…",
      empty: "На этой земле ещё не размещены Frozen Artworks.", untitled: "Работа без названия", view: "Открыть →",
    },
    zoomHint: {
      copy: "Приближайте, чтобы исследовать The Grid. При максимальном увеличении вы увидите, что создатели опубликовали на каждом участке.",
      controlDesktop: "Колёсико или трекпад для масштабирования",
      controlMobile: "Сведите пальцы для масштабирования",
      dontShow: "Больше не показывать",
      close: "Закрыть",
      enteringParcels: "Вы входите в участки",
    },
  },
  nav: {
    marketplace: "Маркетплейс",
    feed: "Лента",
    rent: "RENT",
    overview: "Обзор",
    about: "Проект",
    howItWorks: "Как это работает",
    explore: "Исследовать",
    creators: "Авторы и бренды",
    creatorsShort: "Авторы",
    territory: "Территория",
    profile: "Профиль",
    enterGrid: "Войти в Grid",
    signIn: "Войти",
    navigate: "Навигация",
    purchaseBadge: "Покупка",
    openMenuAria: "Открыть меню навигации",
    closeMenuAria: "Закрыть меню навигации",
    primaryAria: "Основная",
    howItWorksHintAria: "Впервые здесь? Узнайте, как работает THE GRID",
  },
  lang: { ariaLabel: "Язык", menuLabel: "Выбрать язык" },
  wallet: {
    connect: "Подключить",
    connecting: "Подключение…",
    myTerritories: "Мои территории",
    sessionDetails: "Данные сессии",
    disconnect: "Отключить",
  },
  auth: {
    title: "Сессия",
    subtitle: "Аутентификация через кошелёк · SIWE + EIP-1271/6492",
    walletLabel: "Кошелёк",
    sessionLabel: "Сессия",
    connectPrompt: "Подключите кошелёк через верхнюю панель, чтобы включить вход.",
    loading: "Загрузка…",
    signedInAs: "Вы вошли как {wallet}",
    expires: "истекает: {date}",
    signOut: "Выйти",
    signIn: "Войти через Ethereum",
    chain: "сеть: {name} ({id})",
    status: {
      requestingNonce: "Запрос nonce…",
      requestingSignature: "Запрос подписи у кошелька…",
      verifying: "Проверка подписи…",
      signedIn: "Вы вошли как {wallet} (путь: {path})",
      signedOut: "Вы вышли",
    },
  },
  home: {
    hero: {
      eyebrow: "// ОДИН МИР. КОНЕЧНЫЕ ВОЗМОЖНОСТИ.",
      paragraph:
        "Единая конечная территория из одного миллиона ячеек. Исследуйте, занимайте и владейте on-chain. Каждый участок чеканится из одного и того же реестра, выделяется один раз, навсегда.",
      enterGrid: "Войти в Grid",
      scrollLine1: "Прокрутите, чтобы",
      scrollLine2: "Исследовать",
      scrollAria: "Прокрутите, чтобы исследовать",
    },
    instrument: {
      title: "Панель",
      labels: { grid: "СЕТКА", chain: "СЕТЬ", maxZoom: "MAX·Z", auth: "AUTH" },
    },
    callouts: {
      gridZero: { title: "Grid Zero", body: "Ядро территории" },
      lattice: { title: "Решётка данных", body: "Границы зон on-chain" },
      cells: { label: "Ячейки · Конечны" },
    },
    features: [
      { title: "Конечность по замыслу", body: "1 000 000 ячеек. Не больше." },
      { title: "Построено на Base", body: "On-chain-территория · сегодня на Base Sepolia." },
      { title: "Открыто для всех", body: "Читайте карту без кошелька." },
      { title: "Владение кошельком", body: "SIWE · EIP-1271 · EIP-6492 проверены." },
    ],
    story: {
      eyebrow: "Наша история",
      titleLine1: "НОВАЯ",
      titleLine2: "ЭРА",
      titleHighlight: "ВЛАДЕНИЯ",
      paragraph:
        "Grid родилась из простой идеи: цифровая территория, конечная по своей природе, чьи границы живут в реестре — а не на маркетинговой странице. То, чем вы владеете здесь, помнит блокчейн.",
    },
    roadmap: {
      phaseLabel: "Этап",
      eyebrow: "Хронология",
      phasesLive: "{live} из {total} фаз активны",
      title: "ЧТО ГОТОВО. ЧТО ДАЛЬШЕ.",
      paragraph:
        "Честная карта, читается прямо из Base. «Основа» и «Владение» активны уже сегодня — занимайте, создавайте, публикуйте и будьте найдены прямо сейчас. Сейчас мы на этапе финальной доработки и исправлений; следующая крупная веха — Mainnet, и она появится здесь только тогда, когда её сделает реальной реестр, а не текст.",
      status: { live: "Активно", next: "В процессе", later: "В планах" },
      phases: [
        {
          title: "Основа",
          items: [
            "Каноническая территория из 1 000 000 ячеек на Base",
            "Живой on-chain-индексатор + reconciler",
            "Аутентификация кошелька SIWE · EIP-1271 · EIP-6492",
            "Публичное исследование без кошелька",
          ],
        },
        {
          title: "Владение и создание",
          items: [
            "Занятие участка и расчёт в USDC на Base",
            "Canvas для авторов — ссылки, соцсети, медиа, шаблоны",
            "Опциональный 3D-воксельный слой",
            "Публикация + честное обнаружение в Explore",
          ],
        },
        {
          title: "Финальная доработка",
          items: [
            "Приёмочные исправления и доработка UX",
            "Полная многоязычная поддержка",
            "Укрепление и финальное QA перед запуском",
            "Страница предпросмотра Parcel RENT · релиз планируется в Q1 2027",
          ],
        },
        {
          title: "Mainnet",
          items: [
            "Развёртывание в Mainnet (Base)",
            "Предложения, вторичный рынок и активность",
            "Сертификаты и верификация авторов",
            "Публичные API и расширения",
          ],
        },
      ],
    },
    cta: {
      eyebrow: "Вход",
      titlePrefix: "ВЫБЕРИТЕ СВОЮ",
      titleHighlight: "ТЕРРИТОРИЮ",
      paragraph:
        "Карта, которую вы исследовали, публична. Владение — нет. Войдите с помощью кошелька, чтобы занять свою позицию — реестр её запомнит.",
      exploreGrid: "Исследовать Grid",
      signIn: "Войти через Ethereum",
    },
    footer: {
      legalAria: "Правовое",
      legalToggle: "Правовая информация",
      walletAuth: "Аутентификация кошельком",
      territoryData: "Данные территории · читаются on-chain",
    },
    slidedots: {
      aria: "Навигация по разделам",
      overview: "Обзор",
      story: "История",
      territory: "Территория",
      roadmap: "Roadmap",
      enter: "Вход",
    },
  },
  about: {
    eyebrow: "Манифест",
    titleLine1: "ОДИН КОНЕЧНЫЙ",
    titleHighlight: "МИР.",
    intro:
      "THE GRID — это единая конечная цифровая территория из одного миллиона ячеек, выделенная один раз и принадлежащая on-chain. Вот во что мы верим и что продукт действительно делает — ничего больше, ничего выдуманного.",
    principles: [
      {
        title: "Конечность по построению",
        body: "Одна территория. Один миллион ячеек. Не больше. Здесь дефицит — не маркетинговый ход: он записан в контракте, и его нельзя раздуть.",
      },
      {
        title: "Владение живёт on-chain",
        body: "Участок — это on-chain-актив на Base. То, чем вы владеете, фиксирует реестр, а не мы. Границы вашей территории проверяемы, а не обещаны.",
      },
      {
        title: "Публично по умолчанию",
        body: "Любой может читать карту — без кошелька, без регистрации. Обнаружение открыто. Только владение требует доказать, кто вы.",
      },
      {
        title: "Холст, а не билборд",
        body: "Каждая территория — это настоящая площадка дизайна: текст, ссылки, соцсети, медиа, формы и опциональный 3D-слой, всё в рамках честного бюджета Grid-Power, полученного из вашей земли.",
      },
      {
        title: "Ваша личность, подтверждена",
        body: "Sign-In With Ethereum с кошельками EOA и смарт-контрактов (EIP-1271 / EIP-6492). Мы никогда не храним ваши ключи и не двигаем ваши средства.",
      },
      {
        title: "Создано, чтобы длиться",
        body: "Опубликованный контент — это надёжный снимок, отдельный от вашего рабочего черновика. Последующее редактирование не ломает то, что публика уже видит, пока вы не опубликуете заново.",
      },
    ],
  },
  how: {
    eyebrow: "Путь",
    titleLine1: "ОТ КАРТЫ",
    titleLine2: "К ВЛАДЕНИЮ.",
    intro:
      "Шесть реальных шагов, каждый подкреплён уже работающей функцией. Это весь цикл — исследуйте, занимайте, оформляйте, публикуйте и будьте найдены.",
    stepLabel: "ШАГ {n}",
    toggle: { show: "Как это работает", hide: "Скрыть", aria: "Показать простое пошаговое объяснение" },
    steps: [
      {
        title: "Исследуйте карту",
        body: "Откройте Территорию и перемещайтесь по конечной Grid 1000×1000. Приблизьте любой участок, чтобы увидеть, кто чем владеет — без кошелька.",
        detail: {
          intro: "Осматриваться совершенно бесплатно и публично — без кошелька, без аккаунта.",
          points: [
            "Откройте «Территория» в верхнем меню, чтобы увидеть всю карту: единую сетку из 1 000 000 маленьких квадратов (ячеек).",
            "Тяните, чтобы двигаться, крутите колесо для зума. Приблизьте любую область, чтобы увидеть, какая земля занята и что владельцы разместили там.",
            "Здесь ничто не просит вас входить — читать карту всегда открыто для всех.",
          ],
        },
      },
      {
        title: "Займите свой участок",
        body: "Нарисуйте прямоугольник на свободной земле и займите его на Base. Владение чеканится on-chain — вашу позицию фиксирует реестр, а не мы.",
        detail: {
          intro: "«Занять» — значит стать владельцем прямоугольника свободных ячеек. Владение записывается в Base, публичный блокчейн.",
          points: [
            "Вам понадобится крипто-кошелёк — небольшое бесплатное приложение в браузере, которое подтверждает, что это вы, и одобряет действия.",
            "Сегодня THE GRID работает на Base Sepolia, тестовой сети, поэтому вы используете тестовый USDC — не настоящие деньги.",
            "На карте нарисуйте прямоугольник на свободной земле и подтвердите. Ваш кошелёк подписывает, и участок чеканится вам.",
          ],
        },
      },
      {
        title: "Оформите свой Canvas",
        body: "Превратите территорию в настоящую страницу: заголовки, ссылки, соцсети, контакты, медиа и формы — или начните с одного из шести премиум-шаблонов. Всё умещается в честный бюджет Grid-Power из площади вашей земли.",
        detail: {
          intro: "Ваш участок — это чистая страница, которой управляете вы. Заполните её или начните с готового шаблона.",
          points: [
            "Добавьте заголовки, ссылки, кнопки соцсетей, контакты, изображения, видео и простые формы.",
            "Хотите фору? Загрузите один из шести премиум-шаблонов и настройте каждую деталь.",
            "У каждого участка есть бюджет Grid-Power по его размеру — больше земли позволяет разместить больше. Это держит страницы честными и быстрыми.",
          ],
        },
      },
      {
        title: "Добавьте 3D-слой (опционально)",
        body: "Придайте территории глубину воксельной сценой, в которую посетители входят при приближении. Полностью опционально — плоский Canvas тоже полноценный результат.",
        detail: {
          intro: "Поверх плоской страницы можно добавить небольшую 3D-сцену из блоков (вокселей).",
          points: [
            "Посетители входят в сцену, приближаясь вглубь вашего участка.",
            "Это полностью опционально — создавать её необязательно.",
            "Плоский Canvas без 3D — это полноценный первоклассный результат.",
          ],
        },
      },
      {
        title: "Опубликуйте",
        body: "Публикация делает надёжный снимок сохранённого черновика. Продолжайте редактировать приватно — публика видит именно то, что вы опубликовали, пока вы не опубликуете заново.",
        detail: {
          intro: "Публикация создаёт публичную копию вашей работы — а ваш приватный черновик остаётся вашим для редактирования.",
          points: [
            "Она делает надёжный снимок сохранённого черновика и показывает его миру.",
            "После этого можно продолжать редактировать приватно; посетители по-прежнему видят опубликованную версию.",
            "Ничто из изменённого не станет публичным, пока вы не опубликуете снова.",
          ],
        },
      },
      {
        title: "Будьте найдены",
        body: "Каждая действующая публикация появляется в Explore, сначала новые — без платного ранжирования и фейкового тренда. Реальное владение, реальный контент, честный порядок.",
        detail: {
          intro: "После публикации ваша территория попадает в список для всех — автоматически и честно.",
          points: [
            "Она появляется на странице Explore, сначала новые.",
            "Нельзя заплатить за место повыше, и нет фейкового «тренда».",
            "Реальное владение, реальный контент, честный порядок.",
          ],
        },
      },
    ],
    before: {
      eyebrow: "Начните здесь",
      title: "Прежде чем начать",
      intro: "Чтобы осмотреться, почти ничего не нужно. Кошелёк нужен только когда вы решаете владеть землёй.",
      items: [
        { title: "Чтобы исследовать: ничего", body: "Читать карту и открывать любую опубликованную страницу полностью публично — без кошелька, без регистрации." },
        { title: "Крипто-кошелёк", body: "Чтобы занять и владеть, нужен кошелёк: небольшое бесплатное приложение в браузере, которое подтверждает, что это вы. Мы никогда не храним ваши ключи и средства." },
        { title: "Тестовые средства, не настоящие деньги", body: "Сегодня THE GRID работает на Base Sepolia, бесплатной тестовой сети. Вы используете тестовый USDC, чтобы безопасно всё попробовать." },
        { title: "Несколько минут", body: "Занять, оформить и опубликовать — это минуты, а не часы." },
      ],
    },
    journey: {
      eyebrow: "От начала до конца",
      title: "Полный путь",
      intro: "Весь цикл с одного взгляда. Каждый шаг естественно ведёт к следующему.",
      optional: "опционально",
      steps: ["Исследовать", "Занять", "Оформить", "3D-слой", "Опубликовать", "Быть найденным"],
    },
    draft: {
      eyebrow: "Две версии",
      title: "Черновик и Публикация",
      intro: "Ваша работа всегда живёт в двух местах. Понять разницу — это весь секрет.",
      draftLabel: "Черновик",
      draftBody: "Ваша приватная рабочая копия. Её видите только вы. Редактируйте сколько угодно и когда угодно.",
      publishedLabel: "Опубликовано",
      publishedBody: "Надёжный публичный снимок. Именно его видят посетители. Он не меняется, пока вы не опубликуете снова.",
      takeaway: "Редактировать черновик всегда безопасно — публика продолжает видеть вашу последнюю опубликованную версию.",
    },
    levels: {
      eyebrow: "Три уровня зума",
      title: "Как воспринимается THE GRID",
      intro: "Одна и та же территория раскрывается тем больше, чем ближе вы смотрите.",
      items: [
        { tag: "Отдалённо", title: "Карта", body: "Увидьте всю конечную территорию сразу и где что находится." },
        { tag: "Приближенно", title: "Страница", body: "Приблизьте участок — и он становится настоящей страницей: Canvas владельца с текстом, ссылками и медиа." },
        { tag: "Глубже (опционально)", title: "В 3D", body: "Продолжайте приближать участок с 3D-слоем — и вы входите в его воксельную сцену." },
      ],
    },
    faq: {
      eyebrow: "Вопросы новичка",
      title: "FAQ для новичков",
      intro: "Впервые на THE GRID или в Web3? Начните здесь.",
      items: [
        { q: "Нужен ли кошелёк, чтобы просто посмотреть?", a: "Нет. Исследовать карту и открывать любую опубликованную страницу полностью публично и бесплатно." },
        { q: "Что такое «кошелёк»?", a: "Небольшое приложение — часто расширение браузера — которое хранит вашу on-chain-личность и позволяет одобрять действия. Контроль остаётся у вас; мы никогда не храним ваши ключи и средства." },
        { q: "Это настоящие деньги?", a: "Сегодня нет. THE GRID работает на Base Sepolia, бесплатной тестовой сети, с тестовым USDC — чтобы вы могли всё безопасно попробовать." },
        { q: "Что такое ячейки и участки?", a: "THE GRID — это единая карта из 1 000 000 маленьких квадратов, называемых ячейками. Участок — это прямоугольник ячеек, которым вы владеете." },
        { q: "Можно ли изменить страницу после публикации?", a: "Да. Вы храните приватный черновик и можете редактировать в любой момент. Публика продолжает видеть вашу последнюю опубликованную версию, пока вы не опубликуете снова." },
        { q: "Что такое Grid-Power?", a: "Простой бюджет по размеру вашей земли, ограничивающий, сколько можно разместить, и сохраняющий страницы честными и быстрыми в загрузке." },
      ],
    },
  },
  explore: {
    eyebrow: "Обнаружение",
    titleLine1: "ОПУБЛИКОВАННЫЕ",
    titleHighlight: "ТЕРРИТОРИИ.",
    intro:
      "Реальные, действующие прямо сейчас территории на THE GRID — сначала новые. Без платного ранжирования, без выдуманного тренда, без фейковых счётчиков. Откройте любую, чтобы увидеть её публичную страницу.",
    error: {
      title: "Не удалось загрузить публичный каталог",
      body: "Сервис обнаружения сейчас недоступен. Пожалуйста, попробуйте снова через мгновение.",
      retry: "Повторить",
    },
    empty: {
      title: "Карта ждёт",
      body: "Пока не опубликовано ни одной территории. Когда авторы опубликуют свой Canvas, они появятся здесь — сначала новые. Вы можете стать первым.",
      claim: "Займите свою территорию",
      how: "Как это работает",
    },
    liveOne: "{count} активная территория",
    liveOther: "{count} активных территорий",
    modulesOne: "{count} модуль",
    modulesOther: "{count} модулей",
    untitled: "Территория без названия",
    view: "Открыть территорию",
    badgeMedia: "Медиа",
  },
  creators: {
    eyebrow: "Авторы и бренды",
    titleLine1: "ВАША ТЕРРИТОРИЯ,",
    titleHighlight: "ВАША СЦЕНА.",
    intro:
      "Что бы вы ни создавали, для этого есть отправная точка. Шесть премиум-шаблонов Canvas превращают вашу территорию в готовую страницу за минуты — а дальше вы правите каждый пиксель. Шаблоны загружаются в ваш черновик в редакторе; ничего не публикуется, пока вы не решите.",
    sixTemplates: "Шесть премиум-шаблонов",
    useCases: {
      creator: "Для авторов, строящих личный бренд — одна яркая идентичность, био и один призыв к действию.",
      retail: "Для небольших магазинов и брендов — заголовок над витриной товаров с понятным путём к покупке.",
      gallery: "Для художников — работа ведёт, тихое высказывание следует.",
      music: "Для релизов и живых событий — название, дата, место и прямая ссылка на билеты / стрим.",
      product: "Для запусков — заголовок, поддерживающая строка, три блока функций и CTA.",
      minimal: "Для премиального минимализма — сдержанность, воздух и одно продуманное действие.",
    },
    noteBefore: "Шаблоны живут в редакторе Canvas для территории, которой вы владеете. Откройте территорию, нажмите ",
    noteBold: "Шаблоны",
    noteAfter: ", выберите отправную точку — она заполнит ваш черновик, а «Сохранить» / «Опубликовать» остаются в ваших руках.",
    howCta: "Как это работает",
  },
  rent: {
    eyebrow: "Запланированная функция",
    titleLine1: "PARCEL",
    titleHighlight: "RENT",
    intro: "Запланированная возможность для владельцев территорий сдавать в аренду брендам лишь часть своей территории для временных рекламных кампаний — с сохранением полного права собственности на участок.",
    release: "Планируемый релиз: Q1 2027",
    status: "Пока недоступно · Информационный предпросмотр",
    coexist: {
      eyebrow: "Общая территория",
      title: "Одна территория. Две отдельные зоны.",
      body: "Владелец сохраняет своё пространство и идентичность. Кампания спонсора располагалась бы только в арендованной зоне и на ограниченный срок — обе зоны существуют рядом, никогда не смешиваясь.",
      ownerLabel: "Владелец",
      sponsorLabel: "Спонсор",
      ownerLegend: "Зона владельца — остаётся у владельца",
      sponsorLegend: "Зона спонсора — в аренде, на ограниченный срок",
      caption: "Иллюстративный пример — не реальная территория и не реальная кампания",
    },
    how: {
      eyebrow: "Как это планируется",
      steps: [
        { title: "Собственность сохраняется", body: "Участок и его NFT никогда не переходят к другому владельцу во время аренды." },
        { title: "В аренду сдаётся только часть", body: "Владелец выбирает, какую зону предложить; остальная территория остаётся нетронутой." },
        { title: "Временные кампании", body: "Спонсор сможет публиковать только в одобренной зоне, а доступ прекращается по окончании срока аренды." },
        { title: "Проверено и официально", body: "Планируемая проверка личности участников RENT и оплата через официальный процесс аренды The Grid." },
      ],
    },
    model: {
      eyebrow: "Предлагаемая бизнес-модель",
      title: "Доход от аренды для владельцев. Комиссия для The Grid.",
      body: "Согласно предлагаемой модели, владелец территории может получать доход от арендованной зоны, а The Grid — комиссию с каждой официальной арендной сделки.",
      cards: [
        { title: "Владельцы", body: "Возможный доход от аренды части территории без продажи участка." },
        { title: "Бренды", body: "Временное рекламное присутствие на избранных территориях авторов." },
        { title: "The Grid", body: "Комиссия с официальных арендных сделок." },
      ],
      note: "Размер комиссии, цены и условия аренды пока не определены.",
    },
    disclaimer: "Parcel RENT — запланированная функция, сейчас она недоступна. Бронирование, оплата или аренда сегодня невозможны. Детали, условия участия, цены и сроки запуска могут измениться; доход, трафик или результаты не гарантируются.",
  },
  shellCta: {
    title: "Карта публична. Владение — нет.",
    body: "Свободно исследуйте каждую опубликованную территорию. Когда будете готовы занять позицию, войдите с помощью кошелька — реестр её запомнит.",
    explore: "Исследовать территории",
    enterGrid: "Войти в Grid",
  },
  onboarding: {
    profileEntry: { eyebrow: "Пошаговая настройка" },
    eyebrow: "Пошаговая настройка",
    title: "Запустите свою территорию",
    intro: "Пошаговый путь от нуля до опубликованной территории. Ничто не навязывается — выходите в любой момент и продолжайте с того места, где остановились. Каждый шаг ведёт к реальному инструменту, а прогресс сохраняется.",
    authRequired: {
      title: "Войдите, чтобы начать гид",
      body: "Пошаговая настройка привязана к вашему кошельку, чтобы сохранять прогресс. Подключить кошелёк недостаточно — нужна подписанная сессия.",
      cta: "Войти через Ethereum",
    },
    loading: "Загрузка вашего гида…",
    error: {
      title: "Не удалось загрузить гид",
      body: "Служба гида сейчас недоступна. Пожалуйста, повторите попытку позже.",
      retry: "Повторить",
    },
    progress: {
      label: "Шаг {n} из {total}",
      complete: "{done} из {total} готово",
      statusDone: "Готово",
      statusNow: "Сейчас",
      statusNext: "Далее",
      statusLocked: "Позже",
    },
    restart: "Начать гид заново",
    restartConfirm: "Начать гид заново? Это сбросит только ваш прогресс в гиде — ваши территории, черновики и публикации не затрагиваются.",
    ownershipLost: "Выбранная территория больше не принадлежит этому кошельку. Мы вернули вас к выбору территории.",
    actions: {
      select: "Выбрать",
    },
    personas: {
      selected: "Выбрано",
      creator: {
        label: "Креатор",
        desc: "Личный бренд, портфолио или одна яркая идентичность с чётким призывом к действию.",
      },
      retail: {
        label: "Бизнес / Ритейл",
        desc: "Магазин, продукт или бренд — понятный заголовок над вашим предложением и путь к действию.",
      },
    },
    steps: {
      persona: {
        title: "Кто вы?",
        body: "Скажите, вы Креатор или Бизнес. Мы подстроим отправные точки — изменить можно в любой момент.",
      },
      territory: {
        title: "Получите свою территорию",
        body: "Владейте частью Grid, затем выберите, какую территорию построит этот гид.",
        pick: "Выберите территорию для постройки",
        selectedLabel: "Строится",
        needLand: "У вас пока нет земли. Заявите права на parcel в Grid, чтобы начать.",
        getLand: "Получить землю в Grid",
        nameIt: "Дайте имя этой территории",
        loading: "Разрешение ваших территорий…",
        unavailable: "Данные о владении сейчас не удалось получить. Пожалуйста, повторите позже.",
      },
      start: {
        title: "Выберите, как начать",
        body: "Начните с пустого Canvas или загрузите один из шести премиум-шаблонов и сделайте его своим. Оба открывают реальный редактор — ничего не публикуется, пока вы не решите.",
        blank: "Начать с чистого листа",
        template: "Использовать шаблон",
        hint: "Шаблоны находятся в редакторе в разделе \"Шаблоны\".",
      },
      build: {
        title: "Постройте свою территорию",
        body: "Оформите ваш Canvas: идентичность, медиа, ссылки и контакты. Сохраните черновик, когда он вам понравится — он остаётся приватным до публикации.",
        open: "Открыть редактор Canvas",
        draftSaved: "Черновик сохранён",
        noDraft: "Черновик пока не сохранён",
      },
      publish: {
        title: "Опубликовать",
        body: "Публикация создаёт устойчивый публичный снимок вашего сохранённого черновика. Вы можете продолжать редактировать приватно; публика видит опубликованную версию до повторной публикации.",
        open: "Открыть публикацию",
        published: "Опубликовано",
        notReady: "Сначала сохраните черновик, затем опубликуйте со своей территории.",
      },
      launch: {
        title: "Запуск и рост",
        body: "Ваша территория в эфире. Поделитесь — она автоматически появляется в Explore, сначала самые новые, без платного ранжирования.",
        viewPublic: "Посмотреть вашу публичную страницу",
        explore: "Посмотреть в Explore",
        copyLink: "Скопировать публичную ссылку",
        copied: "Ссылка скопирована",
        locked: "Опубликуйте территорию, чтобы разблокировать этот шаг.",
      },
    },
    guide: {
      title: "Пошаговая настройка",
      heading: "Постройте свою территорию",
      intro: "Добавьте идентичность, визуалы и ссылки, затем сохраните черновик.",
      items: {
        identity: "Добавьте идентичность (заголовок, слоган)",
        media: "Добавьте визуал или медиа",
        social: "Добавьте соцсети / контакты",
        save: "Сохранить черновик",
      },
      back: "Назад к гиду",
      hide: "Скрыть гид",
    },
    entry: {
      eyebrow: "Впервые здесь?",
      title: "Запустим вашу первую территорию",
      body: "Короткий пошаговый путь проведёт вас от получения земли до опубликованной страницы. Ничто не навязывается.",
      start: "Начать гид",
      notNow: "Не сейчас",
      resume: "Продолжить гид",
      restart: "Начать гид заново",
      completed: "Гид завершён",
    },
    creatorsCta: {
      title: "Новичок в THE GRID? Пройдите пошаговый путь.",
      body: "От собственной территории до опубликованной страницы за несколько шагов — шаблоны, постройка, публикация.",
      cta: "Начать пошаговую настройку",
    },
  },
  marketplace: {
    home: {
      eyebrow: "The Grid · Маркетплейс",
      title: "Владейте, торгуйте и коллекционируйте координаты живого мира.",
      subtitle: "Каждое объявление авторитетно на стороне бэкенда и работает по принципу fail-closed. Земельные parcel и замороженные работы рассчитываются через одну и ту же ончейн-инстанцию сеттлмента — ничего никогда не выдумывается.",
      browseLand: "Смотреть Землю",
      browseArtworks: "Смотреть Работы",
      cardLandTitle: "Земля",
      cardLandDesc: "Parcel по фиксированной цене с зонально-авторитетным ценообразованием и кросс-валютными floor.",
      cardArtworksTitle: "Работы",
      cardArtworksDesc: "Замороженные размещённые работы с роялти автору и живыми аукционами.",
      cardMineTitle: "Мой Рынок",
      cardMineDesc: "Ваши объявления, сделанные и полученные офферы и ставки аукционов в одном месте.",
    },
    nav: {
      search: "Поиск",
      searchAria: "Поиск по маркетплейсу",
      notifications: "Уведомления",
      notificationsCountAria: "{count} уведомлений",
    },
    search: {
      title: "Поиск по маркетплейсу",
      subtitle: "Parcel · работы · адреса",
      placeholder: "Parcel #, название работы или адрес кошелька…",
      startTyping: "Начните вводить, чтобы искать объявления и работы.",
      noMatches: "Нет совпадений для «{q}».",
      land: "земля",
      artwork: "работа",
      sellerPrefix: "Продавец {addr}",
      byPrefix: "от {addr}",
      auctionSuffix: " · аукцион",
    },
    notifications: {
      title: "Уведомления",
      offersOne: "{n} оффер на рассмотрение",
      offersMany: "{n} офферов на рассмотрение",
      offersDetail: "Покупатели сделали офферы на ваши активы.",
      outbidOn: "Перебита ставка на {title}",
      anAuction: "аукцион",
      topBid: "Высшая ставка {top} · ваша ставка {yours}",
      allCaughtUp: "Вы всё просмотрели.",
      markAll: "Отметить все",
    },
    land: {
      sectionTitle: "Объявления о Земле",
      loadErrorTitle: "Не удалось загрузить объявления",
      loadErrorDetail: "Индекс маркетплейса сейчас недоступен. Ничего не изменено.",
      emptyNoneTitle: "Пока нет объявлений о земле",
      emptyNoneHint: "Когда владельцы выставят parcel на продажу, они появятся здесь.",
      emptyFilteredTitle: "Ни одно объявление не подходит под фильтры",
      emptyFilteredHint: "Попробуйте расширить диапазон цен или снять фильтр зоны.",
      slots: "{n} слотов",
      filters: {
        zone: "Зона",
        price: "Цена (USDC)",
        min: "Мин",
        max: "Макс",
        minSlots: "Мин. слотов",
        any: "Любой",
        sort: "Сортировка",
        clear: "Сбросить фильтры",
        sortRecent: "Сначала новые",
        sortPriceAsc: "Цена · по возрастанию",
        sortPriceDesc: "Цена · по убыванию",
        sortSlotsDesc: "Сначала крупные",
      },
    },
    zones: {
      all: "Все зоны",
      standard: "Standard",
      premium: "Premium",
      vip: "VIP",
      reserve: "Reserve",
      gridZero: "Grid Zero",
    },
    artworks: {
      loadErrorTitle: "Не удалось загрузить работы",
      loadErrorDetail: "Индекс галереи сейчас недоступен.",
      liveAuctions: "Живые Аукционы",
      live: "{n} в эфире",
      gallery: "Галерея",
      works: "{n} работ",
      emptyTitle: "Пока нет работ",
      emptyHint: "Замороженные работы, размещённые на Grid, появляются здесь для офферов и аукционов.",
      auction: "Аукцион",
      openToOffers: "Открыта для офферов",
      royalty: "{n}% роялти",
      by: "от {addr}",
    },
    detail: {
      backToLand: "Назад к Земле",
      backToArtworks: "Назад к Работам",
      listingNotFound: "Объявление не найдено",
      listingNotFoundDetail: "Это объявление могло быть продано или снято.",
      artworkNotFound: "Работа не найдена",
      artworkNotFoundDetail: "Эта работа могла быть перемещена или удалена.",
      loadingParcel: "Загрузка parcel…",
      loadingArtwork: "Загрузка работы…",
      seller: "Продавец {addr}",
      creatorOwner: "от {creator} · владелец {owner}",
      slots: "Слоты",
      footprint: "Площадь",
      floor: "Floor",
      size: "Размер",
      cells: "Ячейки",
      royalty: "Роялти",
      status: "Статус",
      yourListing: "Ваше объявление",
      buyNow: "Купить",
      unavailable: "Недоступно",
      makeOffer: "Сделать оффер",
      viewOnGrid: "Смотреть на Grid",
      sellerNote: "Вы продавец — покупка и офферы отключены для вашего собственного объявления.",
      ownerNote: "Вы владеете этой работой — офферы и ставки для вас отключены.",
      openOffers: "Открытые Офферы",
      noOffersParcel: "Нет открытых офферов на этот parcel.",
      noOffersArtwork: "Нет открытых офферов на эту работу.",
      auctionTag: "Аукцион",
      openToOffers: "Открыта для офферов",
      currentBid: "Текущая ставка",
      reserve: "Резерв",
      leadingPrefix: "Лидирует {addr} · ",
      noBidsYet: "Ставок пока нет · ",
      minNext: "мин. следующая {amt} {sym}",
      auctionEnded: "Аукцион завершён",
      yourAuction: "Ваш аукцион",
      placeBid: "Сделать ставку",
      buyTitle: "Купить Parcel #{id}",
      buySubtitle: "Сеттлмент по фиксированной цене",
      done: "Готово",
      cancel: "Отмена",
      reserving: "Резервирование…",
      authorizing: "Авторизация…",
      reserveAuthorize: "Зарезервировать и авторизовать",
      signInRequired: "Требуется вход",
      connectSignIn: "Подключите кошелёк и войдите →",
      settlementUnavailable: "Сеттлмент временно недоступен — сейчас ничего не может быть списано.",
      price: "Цена",
      gridFee: "Комиссия Grid",
      settlementAuthorized: "Сеттлмент авторизован",
      settlementAuthorizedBody: "Инстанция сеттлмента подписала ваш permit. Завершите покупку из своего кошелька, чтобы финализировать ончейн.",
      authorityFloor: "Инстанция {addr} · floor {amt} {sym}",
      completePurchase: "Complete purchase",
      checkingAllowance: "Checking allowance…",
      confirmInWallet: "Confirm in your wallet…",
      approvingUsdc: "Approving USDC…",
      settlingOnchain: "Finalizing on-chain…",
      purchaseComplete: "Purchase complete",
      purchaseCompleteBody: "The LAND is now yours. Ownership and listings will refresh shortly.",
      buyFailed: "Purchase failed",
      approveRejected: "USDC approval was rejected in your wallet.",
      approveReverted: "The USDC approval transaction reverted on-chain.",
      fillRejected: "The purchase was rejected in your wallet.",
      fillReverted: "The purchase transaction reverted on-chain.",
      wrongBuyerWallet: "Connect the buyer wallet {addr} to complete the purchase.",
      makeOfferTitle: "Сделать оффер",
      makeOfferSubtitle: "Обязывающий оффер · истечение по market-time",
      submitOffer: "Отправить оффер",
      submitting: "Отправка…",
      amount: "Сумма",
      expiresIn: "Истекает через",
      dur1h: "1 час",
      dur24h: "24 часа",
      dur3d: "3 дня",
      dur7d: "7 дней",
      placeBidTitle: "Сделать ставку",
      auctionFallback: "Аукцион",
      signing: "Подпись…",
      yourBid: "Ваша ставка ({sym})",
      minNextBid: "Минимальная следующая ставка: {amt} {sym}",
      bidPermitSigned: "Permit ставки подписан",
      bidPermitBody: "Инстанция сеттлмента подписала ваш permit ставки. Отправьте его из своего кошелька, чтобы записать ставку ончейн.",
      antiSnipe: " Ваша ставка попадает в анти-снайп окно и продлит аукцион.",
      authorityMin: "Инстанция {addr} · мин. принято {amt} {sym}",
    },
    provenance: {
      title: "История / Происхождение",
      empty: "Пока нет истории владения для этого участка.",
      resale: "Перепродажа",
      primaryPurchase: "Первичная покупка",
      privateSale: "Частная продажа",
      transfer: "Передача",
      from: "От",
      to: "Кому",
      price: "Цена",
      fee: "Комиссия",
      net: "Нетто",
      viewTx: "Смотреть tx →",
      currentNameLabel: "Текущее имя",
    },
    owner: {
      cancelPrivateSale: "Отменить",
      cancelBlocked: "Нельзя отменить",
      cancelUnsupportedNote: "Ончейн-отмена частной продажи не поддерживается развёрнутым контрактом. Запросы на отмену безопасно отклоняются и никогда не изменяют запись.",
      cancelPsTitle: "Отменить частную продажу",
      cancelPsBadge: "Действие владельца",
      cancelPsWarning: "Будет запрошена ончейн-отмена частной продажи. Она вступает в силу только после подтверждения транзакции ончейн.",
      cancelPsSuccess: "Частная продажа отменена ончейн.",
      cancelPsConfirm: "Запросить отмену",
      cancelPsClose: "Закрыть",
      cancelPsUnsupported: "Развёрнутый контракт не поддерживает ончейн-отмену частной продажи. Ни одна запись не изменена.",
      psStatusActive: "Активна",
      psStatusCompleted: "Завершена",
      psStatusExpired: "Истекла",
      psStatusCancelled: "Отменена",
      verifyingAccess: "Проверка доступа owner…",
      accessDeniedTitle: "Требуется доступ owner",
      accessDeniedHint: "Эта консоль ограничена кошельками owner из серверного allow-list. Войдите с кошелька admin.",
      loadErrorTitle: "Не удалось загрузить Owner Console",
      loading: "Загрузка Owner Console…",
      integrityTitle: "Целостность Supply",
      noFreeGrant: "Нет бесплатного grant ✓",
      grantAnomaly: "Аномалия grant ✕",
      supplyActiveListings: "Активные Объявления",
      supplySoldListings: "Проданные Объявления",
      supplyOpenOffers: "Открытые Офферы",
      supplyOpenAuctions: "Открытые Аукционы",
      supplyPendingSettlements: "Ожидающие Сеттлменты",
      supplyPaidAcquisitions: "Оплаченные Приобретения",
      zeroPriceGrants: "Grant с нулевой ценой",
      actionsTitle: "Действия Owner",
      gridZeroManual: "Grid Zero вручную",
      releaseLabel: "Release",
      releaseDesc: "Сделать подходящий инвентарь доступным. Cell-authoritative: освобождены, фактически не зарезервированы, не заняты.",
      relockLabel: "Relock",
      relockDesc: "Повторно заблокировать доступный инвентарь. Никогда не блокирует проданные, занятые или иным образом непригодные ячейки.",
      privateSaleLabel: "Частная Продажа",
      privateSaleDesc: "Создать продажу для конкретного покупателя. Цена tier официальная; Grid Zero — вручную. Цена должна быть > 0.",
      failClosed: "Fail-closed",
      unavailable: "Недоступно",
      privateSalesTitle: "Частные Продажи",
      noPrivateSalesTitle: "Частные продажи не запланированы",
      noPrivateSalesHint: "Частные продажи появляются здесь после создания ончейн — отменяемы до pending.",
      buyer: "покупатель {addr}",
      perSlot: "/ слот",
      executed: "Выполнена",
      pending: "В ожидании",
      supplyCheckTitle: "Проверка Supply",
      walletPlaceholder: "адрес кошелька 0x",
      checking: "Проверка…",
      auditWallet: "Проверить кошелёк",
      supplyCheckFailed: "Проверка supply не удалась",
      owned: "Во владении",
      paidOrigin: "Оплаченное происхождение",
      integrity: "Целостность",
      consistent: "Согласовано",
      anomalies: "Аномалии",
      confirmationSuffix: "подтверждение: {tier}",
      tierNormal: "обычное",
      tierStrong: "строгое",
      tierMaximum: "максимальное",
      failClosedBanner: "Fail-closed: {reason}. Это действие не может быть выполнено — ничего не списывается и не выдумывается.",
      typeToProceedPre: "Введите ",
      typeToProceedPost: ", чтобы продолжить",
      ack: "Я понимаю, что это cell-authoritative действие owner, и подтверждаю цель и количество.",
      confirmAction: "Подтвердить {action}",
      submitting: "Отправка…",
      cancel: "Отмена",
      zoneLabel: "Зона",
      slotsLabel: "Слоты",
      buyerLabel: "Кошелёк покупателя",
      priceLabel: "Цена за единицу (USDC)",
      priceHintGridZero: "Grid Zero требует ручную цену за единицу > 0.",
      priceHintTier: "Цена tier официальная и применяется автоматически.",
      actionSuccess: "Действие owner выполнено",
      actionSuccessBody: "{action}: {count} ячеек в {zone} — записано в неизменяемый audit owner. Без бесплатного grant, без ончейн-записи.",
      demoScope: "Preview Demo — изолированный substrate, без ончейн-записи",
    },
    common: {
      parcelNumber: "Parcel #{id}",
      partialTag: "ЧАСТИЧНО",
      close: "Закрыть",
      retry: "Повторить",
    },
    confirm: {
      normal: "Пожалуйста, подтвердите это cell-authoritative действие owner.",
      strong: "Это затрагивает {slots} слотов (более {threshold}). Введите точное число слотов повторно, чтобы продолжить.",
      maximum: "GRID ZERO — самый чувствительный инвентарь на THE GRID. Максимальное подтверждение требуется независимо от количества.",
    },
    statePill: {
      active: "активно",
      sale_pending: "продажа в ожидании",
      confirming: "подтверждается",
      sold: "продано",
      expired: "истекло",
      cancelled: "отменено",
      reconciliation_required: "требуется сверка",
      open: "открыто",
    },
    errors: {
      unauthenticatedTitle: "Требуется вход",
      unauthenticatedHint: "Подключите кошелёк и войдите, чтобы авторизовать это действие.",
      disabledTitle: "Рынок на паузе",
      disabledHint: "Сеттлмент временно недоступен. Ничего не списано и не изменено — попробуйте снова после возобновления.",
      cellLockedTitle: "Зарезервировано другим покупателем",
      cellLockedHint: "Одна или несколько ячеек этого parcel сейчас удерживаются ожидающей покупкой другого покупателя. Повторите через несколько минут.",
      notActiveTitle: "Больше недоступно",
      notActiveHint: "Это объявление больше не активно — возможно, только что продано или снято. Обновите, чтобы увидеть актуальное.",
      expiredTitle: "Объявление истекло",
      expiredHint: "Это объявление истекло и больше не может быть куплено. Владелец может выставить его заново.",
      selfTitle: "Это ваше объявление",
      selfHint: "Вы не можете купить или сделать ставку на актив, который уже продаёте.",
      belowFloorTitle: "Ниже цены floor",
      belowFloorHint: "Цена изменилась и теперь ниже floor продавца. Проверьте и попробуйте снова.",
      settlementTitle: "Сеттлмент выполняется",
      settlementHint: "Для этого актива уже выполняется сеттлмент. Дождитесь завершения перед повтором.",
      reconciliationTitle: "Требуется сверка",
      reconciliationHint: "Этот актив должен быть сверен с chain перед торговлей. Никакое действие не выполнено.",
      spatialTitle: "Конфликт размещения",
      spatialHint: "Эта работа сейчас не в состоянии, пригодном для сеттлмента — возможно, она сдвинулась или перекрывает другое размещение.",
      bidLowTitle: "Ставка слишком мала",
      bidLowHint: "Ваша ставка ниже минимальной следующей ставки. Увеличьте её и попробуйте снова.",
      permitReusedTitle: "Permit уже использован",
      permitReusedHint: "Этот permit ставки уже израсходован. Сделайте новую ставку.",
      auctionClosedTitle: "Аукцион закрыт",
      auctionClosedHint: "Этот аукцион больше не принимает ставки.",
      auctionNotStartedTitle: "Аукцион не начат",
      auctionNotStartedHint: "Этот аукцион ещё не открыт для ставок.",
      sellerBidTitle: "Продавцы не могут делать ставки",
      sellerBidHint: "Вы не можете делать ставки на своём собственном аукционе.",
      permitRefusedTitle: "В авторизации отказано",
      permitRefusedHint: "Инстанция сеттлмента отказалась подписать. Никакое действие не выполнено.",
      noBasisTitle: "Происхождение не записано",
      noBasisHint: "У этого актива ещё нет записанного ОПЛАЧЕННОГО происхождения приобретения, поэтому его нельзя рассчитать. Никакое действие не выполнено.",
      zeroAmountTitle: "Требуется сумма",
      zeroAmountHint: "Введите сумму больше нуля.",
      genericTitle: "Что-то пошло не так",
      genericHint: "Действие не удалось выполнить. Ничего не изменено.",
    },
    tabs: {
      overview: "Обзор",
      land: "Земля",
      artworks: "Работы",
      mine: "Мой Рынок",
      owner: "Owner Console",
      ownerAria: "Owner Console — только admin",
    },
    states: {
      loading: "Загрузка…",
      retry: "Повторить",
      active: "активны",
    },
    paused: {
      title: "Рынок на паузе",
      body: "Сеттлмент временно недоступен. Просмотр остаётся открытым; ничего не может быть списано.",
    },
    mine: {
      signInTitle: "Войдите, чтобы увидеть свой рынок",
      signInHint: "Подключите кошелёк и войдите, чтобы видеть свои объявления, офферы и ставки.",
      connectSignIn: "Подключиться и войти →",
      loadErrorTitle: "Не удалось загрузить ваш рынок",
      loadingYours: "Загрузка вашего рынка…",
      listings: "Мои Объявления",
      listLand: "Продать Землю",
      noListings: "Нет активных объявлений",
      noListingsHint: "Выставьте parcel со страницы его деталей — или через Продать Землю — чтобы продать его.",
      offersReceived: "Полученные Офферы",
      offersMade: "Сделанные Офферы",
      bids: "Мои Ставки",
      noBids: "Нет активных ставок",
      noBidsHint: "Сделайте ставку на живом аукционе, чтобы увидеть её здесь.",
      cancel: "Отменить",
      withdraw: "Отозвать",
      noOpenOffers: "Нет открытых офферов",
      noOffersReceived: "Офферов не получено",
      offerMadeHint: "Сделайте оффер из любого объявления или работы.",
      offerReceivedHint: "Офферы на ваши активы появятся здесь.",
      accept: "Принять",
      decline: "Отклонить",
      accepting: "Принятие…",
      acceptUnsupported: "Этот тип оффера пока нельзя принять здесь.",
      pendingPurchases: "Ожидающие покупки",
      noPendingPurchases: "Нет ожидающих покупок",
      pendingPurchasesHint: "Офферы, принятые продавцом, появятся здесь для завершения покупки.",
      completePurchase: "Завершить покупку",
      auction: "Аукцион",
      leading: "Лидирует",
      outbid: "Перебита",
      bidPrefix: "ставка",
      artworkLabel: "Работа",
      sales: "Продажи",
      purchases: "Покупки",
      noSales: "Продаж пока нет",
      noSalesHint: "Участки, которые вы продаёте на вторичном рынке, появятся здесь.",
      noPurchases: "Покупок пока нет",
      noPurchasesHint: "Участки, которые вы покупаете на вторичном рынке, появятся здесь.",
      soldTo: "Продано",
      boughtFrom: "Куплено у",
      feeShort: "Комиссия",
      netShort: "Нетто",
      soldStatus: "Продано",
      viewTx: "Открыть tx →",
    },
    sell: {
      slotsSelected: "Выбранные ячейки",
      partialBadge: "Частичная область",
      realSelectTitle: "Выберите область для продажи",
      realSelectHint: "Нажмите или перетащите, чтобы выбрать ячейки. Выберите весь участок, чтобы выставить его, или смежную область для частичной продажи.",
      selectWhole: "Выбрать весь участок",
      wholeSelectedNote: "Выбран весь участок — будет выставлен целиком.",
      wholeIneligibleTitle: "Продажа всего участка недоступна",
      wholeIneligibleBody: "Часть этого участка недоступна — активная рыночная блокировка или канонический контент (размещённый арт) занимает одну или несколько ячеек. Листинг всего участка заблокирован, пока эти ячейки не освободятся. Объявление не создано.",
      partialDisabledTitle: "Частичная продажа недоступна",
      partialVaultRequired: "Продажа частичной области требует ончейн дочернего токена SubdivisionVault для этого участка, которого пока нет. Создайте подразделение ончейн, прежде чем выставлять эту область. Объявление не создано.",
      subdivisionTooComplex: "Выбранная форма превышает ончейн-лимит подразделения ({total}/{max} прямоугольников) — измените выбор. Транзакция не отправлена.",
      subAlreadySubdivided: "Этот участок уже подразделён ончейн. Повторное подразделение пока не поддерживается.",
      subDepositFailed: "Не удалось внести участок в хранилище.",
      subSplitFailed: "Ончейн-разделение подразделения не удалось.",
      subGeometryMismatch: "Геометрия дочернего токена ончейн не совпадает с выбором.",
      sub_plan: "Расчёт подразделения…",
      sub_approve: "Одобрение хранилища…",
      sub_approveCollection: "Одобрение маркетплейса…",
      nftApprovalFailed: "Не удалось одобрить передачу для маркетплейса. Объявление не создано.",
      sub_deposit: "Внесение участка…",
      sub_split: "Ончейн-подразделение…",
      sub_reconcile: "Сверка…",
      sub_sign: "Подписать и разместить…",
      wholeTitle: "List the whole parcel",
      wholeSubtitle: "Parcel #{id} · whole parcel",
      wholeBadge: "Whole parcel",
      wholeIntro: "You are authorizing a REAL secondary-market listing of the ENTIRE parcel on Base Sepolia. Your wallet signs an EIP-712 order; nothing is written on-chain until a buyer fills it.",
      wholeConnectRequired: "Connect the owner wallet to authorize this listing.",
      wholeOwnerMismatch: "The connected wallet is not the on-chain owner of this parcel.",
      wholeNotConfigured: "The marketplace contract is not configured for real listings.",
      signAndList: "Sign & list",
      signing: "Awaiting wallet signature…",
      reviewToken: "Token ID",
      reviewCollection: "Collection",
      realCreatedTitle: "Listing authorized",
      realCreatedBody: "Your signed order is live in the marketplace. It settles on-chain only when a buyer fills it.",
      partialFutureTitle: "Sell a subset (partial)",
      partialFutureBody: "Partial sale requires an on-chain subdivision-vault child token, which is not yet available on Base Sepolia. Only whole-parcel listings are possible right now.",
      priceRealHelp: "Set your asking price in {sym}.",
      listLand: "Продать Землю",
      sellLand: "Продать Землю",
      sellLandDemo: "Продать Землю · Preview Demo",
      previewDemo: "Preview Demo",
      previewDemoGrid: "Grid Preview Demo",
      myLand: "Моя Земля",
      selectLand: "Выбрать Землю",
      pickTitle: "Выберите землю для продажи",
      pickHint: "Выберите один из ваших parcel, чтобы выставить непрерывное подмножество ячеек.",
      pickEmpty: "Нет земли для продажи",
      pickEmptyHint: "У вас нет земли, доступной для частичной продажи в этой preview.",
      pickCells: "{n} ячеек",
      pickListed: "{n} активных",
      pickOpen: "Выбрать область →",
      wizardTitle: "Продать Землю",
      wizardSubtitle: "Parcel #{id} · Preview Demo",
      stepSelect: "Выбор области",
      stepPrice: "Цена",
      stepReview: "Обзор",
      selectTitle: "Выберите ячейки для продажи",
      selectHint: "Кликните по ячейке для переключения или зажмите и тяните, чтобы нарисовать прямоугольник. Выбор должен быть одним непрерывным блоком и не может быть всем parcel.",
      selectedCount: "Выбрано {n} из {total} ячеек",
      clearSelection: "Очистить",
      valLoading: "Проверка…",
      valValid: "Выбор верный",
      valInvalid: "Выбор неверный",
      basisLabel: "Стоимость приобретения",
      floorLabel: "Минимальный floor перепродажи (80%)",
      floorBinding: "Обязательный",
      floorNotBinding: "Floor необязателен (basis не записана)",
      reasonOutside: "Ячейки вне parcel",
      reasonNotContiguous: "Ячейки должны образовывать один непрерывный блок",
      reasonFull: "Это весь parcel — используйте объявление на целый parcel",
      reasonNotOwner: "Вы не владелец этой земли",
      reasonOverlap: "Некоторые ячейки пересекаются с существующим объявлением",
      reasonOccupied: "Некоторые ячейки заняты каноническим контентом",
      reasonNoBasis: "Минимальная цена перепродажи недоступна: для этого участка не записана база стоимости приобретения.",
      priceTitle: "Установите цену",
      priceLabel: "Цена",
      currencyLabel: "Валюта",
      priceHelpFloor: "Должно быть не меньше floor в {floor} {sym}.",
      belowFloor: "Цена ниже минимального floor в {floor} {sym}.",
      reviewTitle: "Проверьте и авторизуйте",
      reviewCells: "Ячейки",
      reviewArea: "Область",
      reviewFloor: "Floor",
      reviewPrice: "Ваша цена",
      authorize: "Авторизовать и Опубликовать",
      authorizeDemo: "Авторизовать (Preview Demo) и Опубликовать",
      creating: "Создание объявления…",
      createdTitle: "Демо-объявление создано",
      createdBody: "Ваше preview demo объявление теперь видно в Мои Объявления.",
      viewMine: "Перейти к Мои Объявления",
      demoDisclosureTitle: "Preview Demo — без ончейн / канонических изменений",
      demoDisclosureBody: "Это публикует изолированный демо-parcel на substrate preview. Ваша SIWE-сессия авторизует запись; нет ончейн-минта SubdivisionVault, нет ордера EIP-712, нет сеттлмента на Base Sepolia. В продакшене этот же поток подписывает вашим кошельком и рассчитывается ончейн.",
      back: "Назад",
      next: "Далее",
      close: "Закрыть",
    },
    artworkMkt: {
      buyNow: "Buy now",
      listedAt: "Listed at",
      fixedPrice: "Fixed price",
      yourListing: "Your listing",
      cancelListing: "Cancel listing",
      sellArtwork: "Sell / List Artwork",
      listArtwork: "List / Sell",
      buyTitle: "Buy “{title}”",
      buySubtitle: "Fixed-price artwork settlement",
      buyIntro: "You are buying this artwork at its listed price. Your wallet locks USDC in escrow, then the sale finalizes on-chain. Nothing moves until you confirm.",
      priceLabel: "Price",
      royaltyLabel: "Creator royalty",
      gridFeeLabel: "Grid fee",
      confirmBuy: "Confirm & buy",
      buyPreparing: "Preparing settlement…",
      buyCheckingAllowance: "Checking USDC allowance…",
      buyApprove: "Approve USDC in your wallet…",
      buyApproving: "Approving USDC…",
      buyOpenWallet: "Confirm escrow in your wallet…",
      buyOpening: "Locking funds in escrow…",
      buyIndexingEscrow: "Confirming escrow on-chain…",
      buyAuthorizing: "Authorizing payout…",
      buyReleaseWallet: "Confirm payout in your wallet…",
      buyReleasing: "Releasing payout on-chain…",
      buyIndexingPayout: "Confirming payout finality…",
      buyFinalizing: "Transferring ownership…",
      buyComplete: "Purchase complete",
      buyCompleteBody: "The artwork is now yours. Ownership and listings refresh shortly.",
      buyRejected: "The action was rejected in your wallet.",
      buyReverted: "The transaction reverted on-chain.",
      buyFailed: "Purchase failed",
      connectBuyer: "Connect the buyer wallet {addr} to complete this purchase.",
      sellIntro: "You own this artwork. List it at a fixed price or open a live auction.",
      cancelListingConfirm: "Cancel this listing?",
      listingCancelled: "Listing cancelled.",
      wizardTitle: "Sell Artwork",
      pickTitle: "Choose an artwork to sell",
      pickHint: "Select a frozen, placed artwork you own that isn't already listed or in auction.",
      pickEmpty: "No sellable artworks",
      pickEmptyHint: "You need a frozen artwork placed on the Grid that isn't already listed or auctioned.",
      chooseMode: "How do you want to sell?",
      modeFixed: "Fixed price",
      modeFixedDesc: "List at a set price. Buyers purchase instantly; you sign nothing on-chain.",
      modeAuction: "Auction",
      modeAuctionDesc: "Run a timed English auction with a reserve. You sign the auction creation on-chain.",
      setPrice: "Set your price",
      priceHint: "Set your asking price in {sym}. Grid fee {fee}% + creator royalty {roy}% are deducted on settlement.",
      listBtn: "List for sale",
      listing: "Listing…",
      listedTitle: "Artwork listed",
      listedBody: "Your artwork is now listed at the fixed price. Buyers can purchase it from its detail page.",
      setAuction: "Auction terms",
      reserveLabel: "Reserve price",
      minIncrementLabel: "Minimum bid increment",
      durationLabel: "Duration",
      antiSnipeLabel: "Anti-snipe window",
      dur1h: "1 hour",
      dur6h: "6 hours",
      dur24h: "24 hours",
      dur3d: "3 days",
      dur7d: "7 days",
      antiSnipe60: "60 seconds",
      antiSnipe300: "5 minutes",
      antiSnipeOff: "Off",
      createAuctionBtn: "Create auction",
      creatingAuction: "Creating auction…",
      auctionWalletConfirm: "Confirm auction in your wallet…",
      auctionSubmitting: "Creating auction on-chain…",
      auctionCreatedTitle: "Auction created",
      auctionCreatedBody: "Your auction is live on-chain. Bidders can place bids until it ends.",
      review: "Review",
      reviewArtwork: "Artwork",
      reviewRoyalty: "Royalty",
      reviewMode: "Mode",
      reviewPrice: "Price",
      reviewReserve: "Reserve",
      reviewIncrement: "Increment",
      reviewEnds: "Ends",
      settleAuction: "Settle auction",
      settling: "Settling…",
      settleWalletConfirm: "Confirm settlement in your wallet…",
      settled: "Auction settled",
      cancelAuction: "Cancel auction",
      cancellingAuction: "Cancelling…",
      auctionCancelled: "Auction cancelled.",
      bidPlacedOnchain: "Bid placed on-chain.",
      bidApprove: "Approve USDC in your wallet…",
      bidApproving: "Approving USDC…",
      bidWalletConfirm: "Confirm bid in your wallet…",
      bidSubmitting: "Placing bid on-chain…",
      historyTitle: "History / Provenance",
      historyEmpty: "No sale or auction history yet for this artwork.",
      histPrepared: "Settlement prepared",
      histFinalized: "Sold (fixed price)",
      histAuctionSettled: "Auction settled",
      histFrozen: "Frozen & placed",
      myArtworkListings: "My Artwork Listings",
      noArtworkListings: "No artwork listings",
      noArtworkListingsHint: "List a frozen artwork for sale to see it here.",
      myAuctions: "My Auctions",
      noMyAuctions: "No auctions",
      noMyAuctionsHint: "Create an auction from an artwork you own to see it here.",
      close: "Close",
      cancel: "Cancel",
      back: "Back",
      next: "Next",
      done: "Done",
      viewTx: "View tx →",
      signInFirst: "Connect your wallet & sign in →",
      auctionEnds: "Ends {when}",
    },
    demoGrid: {
      title: "Grid Preview Demo",
      subtitle: "Ваша демо-земля · изолированный substrate preview",
      disclosure: "Это изолированная поверхность PREVIEW DEMO — не каноническая Grid. Ничто здесь не затрагивает реальные parcel, ончейн-владение или Base Sepolia.",
      empty: "У вас нет демо-земли в этой preview.",
      emptyHint: "Войдите с демо-кошелька продавца, чтобы увидеть демо-землю для продажи.",
      returnToMarket: "← Назад в Маркетплейс",
      ownedBadge: "Ваши",
      listedBadge: "{n} в продаже",
      clickToSell: "Кликните по parcel, чтобы продать его часть",
      worldLabel: "Мир 1000 × 1000",
      loadError: "Не удалось загрузить вашу демо-землю",
    },
    clock: {
      closing: "закрытие",
      ended: "Завершено",
    },
    grid: {
      cellAria: "ячейка {x},{y}",
      cellLockedAria: "ячейка {x},{y} (заблокирована)",
    },
  },
  purchase: {
    intro: "Предпросмотр котировки в реальном времени — списание не происходит, пока вы не подтвердите.",
    loading: "загрузка…",
    bootstrapError: "Не удалось загрузить /sale/config или /sale/status: {error}",
    recovery: {
      confirming: "Восстановлена ожидающая покупка — подтверждение в сети Base…",
      syncing: "Подтверждено on-chain — синхронизация с Grid…",
      failed: "Восстановленная транзакция покупки была отменена. Ни один участок не был куплен.",
      degraded: "Сеть временно недоступна — повторная попытка получить статус покупки…",
    },
    sections: {
      contracts: "Контракты on-chain",
      saleStatus: "Статус продажи",
      wallet: "Кошелёк",
      financial: "Баланс и разрешение USDC",
      approval: "Разрешение USDC",
      purchase: "Покупка",
      indexing: "Индексация",
      quote: "Котировка",
    },
    gate: { yes: "ДА", no: "НЕТ ({reason})" },
    wallet: {
      connect: "Подключить {name}",
      disconnect: "Отключить",
      wrongChain: "Кошелёк находится в сети {chainId}, продажа — в {expectedChainId}. Смените сеть в своём кошельке.",
      switching: "Переключение…",
      switchTo: "Переключиться на сеть {chainId}",
      switchRejected: "переключение отклонено",
      switchError: "ошибка переключения: {message}",
    },
    financial: {
      blocked: "чтение отключено: {reason}",
      readError: "ошибка чтения",
      noSellableQuote: "— (нет котировки для покупки)",
      insufficient: "insufficient_balance (не хватает {amount})",
      approval: "approval_required (требуется {amount})",
      ready: "ready_for_purchase",
      rpcError: "Ошибка RPC при чтении состояния USDC.",
      refetch: "Обновить баланс/разрешение",
    },
    approve: {
      blocked: "разрешение отключено: {reason}",
      waitingWallet: "Ожидание кошелька…",
      submitting: "Отправка…",
      confirming: "Подтверждение…",
      cta: "Разрешить точную сумму USDC",
      rejected: "Пользователь отклонил транзакцию разрешения. Можно попробовать снова.",
      reverted: "Транзакция разрешения была отменена on-chain.",
      error: "Ошибка разрешения: {error}",
      confirmed: "Разрешение подтверждено. Запущены обновление разрешения и принудительная перекотировка.",
    },
    tx: {
      blocked: "покупка отключена: {reason}",
      refreshingQuote: "Обновление финальной котировки…",
      awaitingWallet: "Подтвердите в своём кошельке…",
      submitted: "Отправлено…",
      confirming: "Подтверждение в сети Base…",
      cta: "Купить",
      rejected: "Пользователь отклонил транзакцию покупки.",
      reverted: "Транзакция отменена",
      revertedReason: "Транзакция отменена: {reason}",
      error: "Ошибка покупки: {error}",
      confirmed: "Транзакция подтверждена on-chain. Синхронизация с Grid — ожидание индексации на бэкенде…",
    },
    indexing: {
      pending: "Синхронизация с Grid…",
      delayed: "Транзакция подтверждена on-chain. Индексация на бэкенде занимает больше времени, чем ожидалось.",
      checkAgain: "Проверить снова",
      success: "В собственности · Live. Покупка успешно проиндексирована.",
      buyAnother: "Купить ещё один участок",
      anomaly: "Обнаружена аномалия индексации ({reason}). Транзакция on-chain подтверждена, но проиндексированная запись не совпадает с исходным снимком покупки. Обратитесь в поддержку, указав хэш транзакции ниже.",
    },
    quote: {
      empty: "Нарисуйте прямоугольник на сетке, чтобы получить котировку.",
      clearSelection: "Очистить выбор",
      occupiedSelf: "Эта область пересекается с участком, которым вы уже владеете. Уже отчеканенную землю нельзя купить повторно.",
      occupiedOther: "Эта область пересекается с землёй, принадлежащей другому кошельку. Нарисуйте по свободной сетке, чтобы купить.",
      occupiedGeneric: "Эта область пересекается с существующими участками и недоступна для покупки. Нарисуйте по свободной сетке.",
      loading: "загрузка котировки…",
    },
    errors: {
      tooWide: "Выбор слишком широкий — один участок может быть шириной не более 250 ячеек. Нарисуйте более узкую область.",
      tooHigh: "Выбор слишком высокий — один участок может быть высотой не более 250 ячеек. Нарисуйте более низкую область.",
      areaExceeds: "Выбор слишком большой — один участок может покрывать не более 10 000 слотов (ячеек){yours}. Нарисуйте область меньше, чтобы получить котировку.",
      areaExceedsYours: " — у вас {slots} слотов",
      outOfBounds: "Выбор выходит за край Grid. Держите его полностью внутри территории 1000 × 1000.",
      zeroOrNegative: "Выбор пуст — нарисуйте прямоугольник шириной хотя бы в одну ячейку.",
      vipCap: "Эта VIP-область превышает коммерческий лимит на участок. Нарисуйте область меньше.",
      zoneCap: "Эта область превышает оставшуюся ёмкость своей зоны. Нарисуйте область меньше.",
      unexpected: "Непредвиденная ошибка.",
    },
  },
  profile: {
    badge: { none: "Пока нет значка" },
    cockpit: {
      title: "Обзор",
      available: "Доступно",
      pendingFunding: "Ожидающее финансирование",
      ownedParcels: "Участки в собственности",
      influence: "Влияние",
      lifetimePts: "всего очков",
      slots: "{n} слотов",
      progressTo: "Прогресс до {badge}",
      max: "макс",
      referralCode: "Реферальный код",
      qualified: "{n} квалифицировано",
      pending: "{n} в ожидании",
    },
    myGrid: {
      loading: "Загрузка вашей сетки…",
      signIn: "Войти",
      unavailable: "Недоступно.",
      failedToLoad: "Не удалось загрузить",
      retry: "Повторить",
      title: "Моя Grid",
      empty: "У вас пока нет земли. Приобретите участок, чтобы начать получать награды Соседства и Влияние.",
      parcels: "Участки",
      totalSlots: "Всего слотов",
      clusters: "Кластеры",
      largestCluster: "Крупнейший кластер",
      slots: "{n} слотов",
      parcelMeta: "{w}×{h} · {area} слотов",
      edgeNeighbors: "{n} соседей по границе",
    },
    influence: {
      title: "Очки Влияния",
      lifetimePrivate: "Всего очков · приватно",
      ptsTo: "{points} очк. до ",
      maxReached: "Достигнут высший значок",
      nextAt: "следующий на {threshold}",
      publicNote: "Публичные поверхности показывают только ваш значок — никогда точный счёт. Без рейтинга.",
    },
    analytics: {
      title: "Аналитика",
      retry: "Повторить",
      loadError: "Не удалось загрузить вашу аналитику.",
      sections: { land: "Земля и владение", creator: "Создатель и рефералы", trends: "Тренды", rewards: "Награды и Влияние" },
      kpi: {
        parcelsOwned: "Участки в собственности",
        totalArea: "Общая площадь",
        primaryAcq: "Первичные приобретения",
        acqVolume: "Объём приобретений",
        ownedTerritories: "Территории в собственности",
        publishedTerritories: "Опубликованные территории",
        createdArtworks: "Созданные работы",
        qualifiedReferrals: "Квалифицированные рефералы",
        influence: "Влияние",
        rewardsAvailable: "Доступные награды",
        totalRewards: "Всего наград",
        pendingFunding: "Ожидающее финансирование",
      },
      cells: "ячейки",
      referralQ: "Квалификации рефералов",
      inRange: "{n} за период",
      noReferrals: "Пока нет квалифицированных рефералов за этот период.",
      rewardsByType: "Награды по типу",
      influenceGrowth: "Рост влияния",
      noInfluence: "Пока нет влияния за этот период.",
      notLiveTitle: "Награды и Влияние пока не активны.",
      notLiveBody: "Эти показатели заполняются автоматически после запуска программы The Grid Rewards. До этого ничего не отслеживается и не оценивается.",
    },
    activity: {
      title: "Активность",
      markAll: "Отметить всё как прочитанное ({n})",
      filters: { all: "Все", rewards: "Награды", land: "Земля", artwork: "Работы", account: "Аккаунт" },
      loadError: "Не удалось загрузить вашу активность.",
      retry: "Повторить",
      empty: "Пока нет активности. Значимые события на вашей Grid появятся здесь.",
      loading: "Загрузка…",
      loadMore: "Загрузить ещё",
    },
    rewards: {
      loading: "Загрузка наград…",
      failedToLoad: "Не удалось загрузить награды",
      auth: { note: "Войдите, чтобы увидеть баланс Наград и выводы.", cta: "Перейти ко входу" },
      unavailable: "Награды недоступны.",
      retry: "Повторить",
      errors: {
        belowMin: "Сумма ниже минимума в 350 USDC.",
        exceedsAvailable: "Сумма превышает ваш Доступный баланс.",
        invalidAmount: "Введите корректную сумму.",
        unauthenticated: "Ваша сессия истекла — войдите снова.",
        failed: "Вывод не удался.",
      },
      balance: {
        title: "Баланс Наград",
        available: "Доступно",
        pendingFunding: "Ожидающее финансирование",
        awaitingVault: "Ожидание финансирования Vault",
        withdrawalPending: "Вывод в ожидании",
        withdrawn: "Выведено",
        expired: "Истекло",
        expiryDeadline: "Срок истечения",
        forfeits: "Доступное сгорает, если не востребовано",
        noTimer: "Нет активного таймера",
      },
      withdraw: {
        title: "Вывести",
        disabledNote: "Для вывода нужно минимум {min} Доступно. Текущий Доступный: {available}.",
        amountLabel: "Сумма (USDC)",
        gasLabel: "Оценка газа сети (USDC · необязательно)",
        allToggle: "Вывести всё Доступное ({available})",
        serviceFee: "Сервисный сбор · 2%",
        gasSeparate: "Газ (отдельно)",
        estimatedNet: "Оценочный нетто",
        minNote: "Минимум {min} брутто. Применяется сервисный сбор 2%; газ сети взимается отдельно и является лишь оценкой.",
        belowMin: "Ниже минимума в 350 USDC.",
        exceeds: "Превышает ваш Доступный баланс.",
        submitting: "Отправка…",
        submit: "Вывести",
        all: "Вывести всё",
        success: "Вывод запрошен — нетто {net} (сбор {fee}, газ {gas}).",
      },
      payout: {
        title: "Нужна помощь с расчётом?",
        body: "Уведомите команду обработать ваш Доступный баланс ({available}). Это не создаёт деньги и никогда не обходит порядок финансирования.",
        reachTitle: "Достигните {min} Доступной прибыли, чтобы запросить выплату",
        sending: "Отправка…",
        cta: "Запросить выплату",
        minHint: "Достигните {min} Доступной прибыли, чтобы запросить выплату — у вас {available}.",
        alreadyOpen: "Запрос на выплату уже открыт.",
        sent: "Запрос на выплату отправлен команде.",
        failed: "Не удалось отправить запрос.",
      },
      history: {
        title: "История Наград",
        empty: "Пока нет наград. Реферальные (7%) и Соседские (3%) награды появятся здесь по мере приобретения земли.",
        referralProv: "Реферал · {pct}% от {gross}",
        neighborProvEdge: "Соседство · {edge}/{total} границы пула {pct}%",
        neighborProvPool: "Соседство · пул {pct}%",
        funded: "Профинансировано",
        pendingFunding: "Ожидающее финансирование",
        parcels: "участки {ids}",
      },
      withdrawals: {
        title: "Выводы",
        pending: "В ожидании",
        withdrawn: "Выведено",
        failed: "Неудача",
        net: "{net} нетто",
        gross: "брутто {x}",
        fee: "сбор {x}",
        gas: "газ {x}",
        failureReason: "· {reason} — возвращено в Доступное для повтора",
      },
    },
  },
  dashboard: {
    publishability: { published: "Опубликовано", publishable: "Можно опубликовать", notPublishable: "Нельзя опубликовать" },
    territory: { fallback: "Территория {ordinal}" },
    route: {
      title: "Мои территории",
      subtitle: "Центр управления владельца · на основе вашей реальной собственности в Сетке",
      backToGrid: "Назад к Сетке",
      authTitle: "Требуется аутентификация",
      authBody: "Войдите с помощью кошелька, чтобы управлять своими территориями. Подключения кошелька недостаточно — требуется подписанная сессия.",
      signIn: "Войти через Ethereum",
      detailEmpty: "Выберите территорию, чтобы увидеть сводку по управлению.",
    },
    list: {
      resolving: "Разрешение ваших территорий…",
      unavailableTitle: "Территории недоступны",
      unavailableBody: "Полные данные о вашей собственности сейчас не удалось разрешить. Частичные данные не показываются. Повторите попытку вскоре.",
      emptyTitle: "Пока нет территорий",
      emptyBody: "У вас пока нет собственности в Сетке.",
      exploreGrid: "Исследовать Сетку",
    },
    card: {
      area: "Площадь",
      gpCapacity: "Ёмкость GP",
      propertyUnits: "Единицы собственности",
      minNote: "Минимум 400 u² для публикации.",
      unreadTitle: "Администратор отправил вам сообщение модерации",
      unreadAria: "Непрочитанное сообщение модерации",
    },
    detail: {
      territoryArea: "Площадь территории",
      gpCapacity: "Ёмкость GP",
      propertyUnits: "Единицы собственности",
      underlyingUnitIds: "ID базовых единиц",
      location: "Расположение (границы мира)",
      minNote: "Эта территория ниже минимума в 400 u², необходимого для публикации.",
    },
    identity: {
      title: "Идентичность территории",
      rev: "рев {n}",
      authRequired: "Для управления идентичностью этой территории требуется подписанная сессия.",
      unavailable: "Управление идентичностью доступно только для законно принадлежащей территории.",
      loading: "Разрешение текущей территории…",
      namePlaceholder: "Отображаемое имя — назовите эту территорию",
      saved: "Сохранено.",
      saving: "Сохранение…",
      saveName: "Сохранить имя",
      editCanvas: "Редактировать холст →",
      saveErrors: {
        STALE_TERRITORY: "Ваша территория изменилась с момента загрузки. Она обновлена — проверьте и сохраните снова.",
        IDENTITY_VERSION_CONFLICT: "Эта идентичность была обновлена в другом месте. Она обновлена — проверьте и сохраните снова.",
        IDENTITY_RECONCILIATION_REQUIRED: "Эта территория теперь объединяется с другой именованной территорией. Перед сохранением требуется согласование.",
        TERRITORY_NOT_PUBLISHABLE: "Эта территория ниже минимума в 400 u², необходимого для публикации.",
        TERRITORY_NOT_IDENTITY_ELIGIBLE: "Управление идентичностью доступно только для законно принадлежащей территории.",
        DISPLAY_NAME_INVALID: "Это имя не разрешено.",
        UNTRUSTED_ORIGIN: "Этот запрос заблокирован в целях безопасности. Перезагрузите страницу и повторите попытку.",
        CSRF_REQUIRED: "Отсутствовал токен безопасности. Перезагрузите страницу и повторите попытку.",
        CSRF_INVALID: "Срок действия токена безопасности истёк. Перезагрузите страницу и повторите попытку.",
        CSRF_FETCH_FAILED: "Не удалось проверить вашу сессию. Перезагрузите страницу и повторите попытку.",
        UNAUTHENTICATED: "Срок действия сессии истёк. Войдите снова, чтобы сохранить.",
        UNSUPPORTED_MEDIA_TYPE: "Что-то пошло не так при отправке запроса. Перезагрузите и повторите попытку.",
        SEED_NOT_OWNED: "Вы больше не владеете этой территорией.",
      },
    },
    reconciliation: {
      intro: "Эта территория теперь объединяет {n} именованных территорий в одну. Выберите, какая идентичность сохранится — остальные будут заменены. Имена не объединяются.",
      metaOne: "{n} ед. · рев {rev}",
      metaOther: "{n} ед. · рев {rev}",
      reconciling: "Согласование…",
      confirmSurvivor: "Подтвердить сохранённую",
      errors: {
        STALE_TERRITORY: "Ваша территория изменилась с момента загрузки. Она обновлена — проверьте и выберите снова.",
        IDENTITY_VERSION_CONFLICT: "Одна из этих идентичностей изменилась в другом месте. Она обновлена — проверьте и выберите снова.",
        RECONCILIATION_NOT_REQUIRED: "Этой территории больше не требуется согласование. Она обновлена.",
        SURVIVOR_NOT_CANDIDATE: "Эта идентичность больше не подходит. Она обновлена.",
        TERRITORY_NOT_PUBLISHABLE: "Эта территория ниже минимума в 400 u², необходимого для публикации.",
        UNTRUSTED_ORIGIN: "Этот запрос заблокирован в целях безопасности. Перезагрузите страницу и повторите попытку.",
        CSRF_REQUIRED: "Отсутствовал токен безопасности. Перезагрузите страницу и повторите попытку.",
        CSRF_INVALID: "Срок действия токена безопасности истёк. Перезагрузите страницу и повторите попытку.",
        CSRF_FETCH_FAILED: "Не удалось проверить вашу сессию. Перезагрузите страницу и повторите попытку.",
        UNAUTHENTICATED: "Срок действия сессии истёк. Войдите снова.",
        TRANSACTION_UNAVAILABLE: "Сервис кратковременно недоступен. Повторите попытку через мгновение.",
        SEED_NOT_OWNED: "Вы больше не владеете этой территорией.",
      },
    },
    brandImage: {
      title: "Изображение бренда · LOD0",
      rev: "рев {n}",
      desc: "Необязательное изображение карты для этой территории (PNG · JPEG · WebP, ≤ 5 MiB, ≤ 2048px). Бесплатно.",
      recommendedPrefix: "Рекомендуется для вашей территории:",
      size: "{rw} × {rh} px",
      ratioNote: "(соотношение {ratio}) — соответствует вашей парцелле, чтобы логотип не растягивался.",
      previewAlt: "Изображение бренда территории",
      unsaved: "Несохранённый предпросмотр — нажмите Сохранить, чтобы оставить его.",
      empty: "Пока нет изображения бренда.",
      saved: "Сохранено.",
      removed: "Изображение бренда удалено.",
      authRequired: "Для управления изображением бренда требуется подписанная сессия.",
      chooseAria: "Выберите изображение бренда",
      replace: "Заменить…",
      select: "Выбрать изображение…",
      saving: "Сохранение…",
      save: "Сохранить",
      cancel: "Отмена",
      remove: "Удалить",
      removeConfirm: "Удалить изображение бренда?",
      removing: "Удаление…",
      confirm: "Подтвердить",
      keep: "Оставить",
    },
    publish: {
      publishing: "Публикация…",
      republish: "Опубликовать заново",
      published: "Опубликовано",
      publish: "Опубликовать",
      blockedSave: "Сохраните черновик перед публикацией",
      stateLabels: {
        UNPUBLISHED: "Не опубликовано",
        PUBLISHED_CURRENT: "Опубликовано · актуально",
        DRAFT_CHANGED: "Опубликовано · черновик изменён",
        TERRITORY_CHANGED: "Опубликовано · территория изменена",
      },
    },
    media: {
      fileTooLarge: "Файл превышает максимум в 250 MiB.",
      title: "Медиатека",
      subtitle: "Повторно используемые медиа вашего кошелька · Изображение 10 · GIF 20 (10с) · PDF 25 · Видео 250 MiB · Библиотека 2 GiB",
      working: "Обработка…",
      upload: "Загрузить",
      used: "{x} использовано",
      free: "{free} свободно из {total}",
      loading: "Загрузка библиотеки…",
      empty: "Пока нет медиа. Загрузите изображение, GIF, PDF или видео, чтобы начать библиотеку.",
      loadMore: "Загрузить ещё",
      pages: "{n} страниц",
      deleteAria: "Удалить ресурс",
    },
  },
  artist: {
    utility: {
      loading: "Загрузка полезности парцеллы…",
      referral: {
        title: "Рефералы",
        yourCode: "Ваш реферальный код",
        copyLink: "Копировать реферальную ссылку",
        copied: "Скопировано",
        qualified: "Квалифицированные рефералы",
        pending: "Ожидающие рефералы",
        empty: "Пока нет рефералов. Поделитесь ссылкой — реферал квалифицируется, когда приглашённый совершает своё первое первичное приобретение земли.",
        preparing: "Ваш реферальный код готовится из канонической собственности — проверьте вскоре.",
        ownToUnlock: "Владейте хотя бы одной парцеллой, чтобы разблокировать реферальный код.",
        wasReferred: "Вы были приглашены · статус",
      },
      parcel: {
        title: "Полезность парцеллы",
        empty: "Сейчас у вас нет ни одной парцеллы. Приобретите землю, чтобы разблокировать полезность парцеллы.",
        parcels: "Парцеллы",
        totalArea: "Общая площадь",
        clusters: "Кластеры",
        largestCluster: "Крупнейший кластер",
        flagBasicIdentity: "Базовая идентичность",
        flagPublishable: "Можно опубликовать",
        flagPublished: "Опубликовано",
        flagHasNeighbors: "Есть соседи",
        neighbors: "{n} соседей",
        cluster: "кластер {size} · {area} u²",
      },
      neighborhood: {
        title: "Окрестности",
        empty: "Владейте парцеллой, чтобы увидеть свои окрестности.",
        edgeNeighbors: "Соседи по границе",
        connectedClusters: "Связанные кластеры",
        connectedClusterLabel: "Связанный кластер",
        clusterSummary: "{size} парцелл · {area} u²",
        openParcel: "Парцелла #{id} — {n} сосед(ей) по границе",
        loading: "Загрузка…",
        noEdgeNeighbors: "Нет соседей по границе.",
        yours: "ваше",
        published: "опубликовано",
      },
    },
    profile: {
      loading: "Загрузка профиля…",
      connectWallet: "Подключите кошелёк",
      connectBody: "Войдите, чтобы увидеть свой профиль Художника, право на участие и Творческую ёмкость.",
      goToSignIn: "Перейти ко входу",
      unavailable: "Профиль недоступен.",
      retry: "Повторить",
      loadFail: "Не удалось загрузить профиль",
      moderationLabel: "Модерация",
      moderationMsg: "Сообщение от админа",
      moderationAria: "У вас есть сообщение от администратора — откройте Мои территории, чтобы прочитать его",
      tabs: { overview: "Обзор", rewards: "Награды", activity: "Активность", analytics: "Аналитика", grid: "Моя Сетка" },
      roleTitle: "Роль",
      roleArtist: "Вы Художник — постоянная идентичность, заработанная через право на землю и стаж.",
      roleNeo: "Вы НеоХудожник — постоянная идентичность с ускоренным доступом к созданию Художника при наличии права. Те же творческие возможности, что и у Художника.",
      roleCreator: "Сейчас вы владеете землёй, поэтому можете использовать творческие инструменты. Создатель — это текущее состояние, оно следует за вашим владением землёй и не является постоянным знаком.",
      roleUser: "Сейчас вы не владеете землёй и не разблокировали постоянную художественную идентичность. Приобретите землю, чтобы стать Создателем, или достигните 50% права для пути НеоХудожника.",
      statusCurrentState: "· текущее состояние",
      eligTitle: "Право на Художника",
      neoThreshold: "Порог НеоХудожника · 50%",
      artistThreshold: "Порог Художника · 100%",
      eligUnits: "{units} / {total} единиц права",
      tierSlots: "{slots} слотов · {units}u",
      tenureTitle: "Стаж Художника · 100 дней",
      tenureBlock: " (блок {block})",
      tenurePending: "Первое приобретение земли записано on-chain{block}. Точная дата разрешается из канонических данных цепочки — стаж отобразится, когда станет доступен. Дата не показывается, пока её нельзя доказать.",
      firstAcq: "Первое приобретение: {date}",
      daysLine: "{days} / {min} дней",
      reqMet: "требование выполнено",
      daysRemaining: "осталось {n} дней",
      ccTitle: "Творческая ёмкость",
      ccTotal: "Всего",
      ccUsed: "Использовано",
      ccAvailable: "Доступно",
      ccNote: "Ёмкость исходит из принадлежащей вам земли и остаётся привязанной к истории каждой парцеллы.",
      neoTitle: "Путь НеоХудожника",
      neoHavePermanent: "У вас уже есть постоянная идентичность {status}.",
      neoNeedElig: "Достигните 50% Права на Художника, чтобы разблокировать ускоренный путь НеоХудожника (сейчас {pct}%).",
      neoEligibleBody: "Вы имеете право на ускоренный путь НеоХудожника (разовая плата, в USDC или USDT). НеоХудожник не даёт дополнительной Творческой ёмкости.",
      neoFee: "Плата: {fee} · {currencies}",
      neoFeeNotConfigured: "Плата ещё не настроена — цена не показывается, пока The Grid её не установит.",
      neoPaymentPending: "Интеграция платежей в ожидании",
      collectionTitle: "Коллекция",
      collCreatedBy: "Создано",
      collOwned: "В собственности",
      collCreatedCount: "{n} создано",
      collCreatedEmpty: "Пока нет замороженных работ.",
      collOwnedEmpty: "Сейчас нет работ в собственности.",
      editTitle: "Редактировать профиль",
      editDisplayName: "Отображаемое имя",
      editBio: "Био",
      editAvatar: "URL аватара (https/ipfs)",
      editSaving: "Сохранение…",
      editSave: "Сохранить",
      editSaved: "Сохранено",
      editSaveFail: "Не удалось сохранить",
    },
  },
  social: {
    follow: { follow: "Подписаться", following: "Вы подписаны", actionFailed: "Действие не удалось" },
    report: {
      moreOptions: "Ещё",
      reason: "Причина",
      report: "Пожаловаться",
      blockUser: "Заблокировать пользователя",
      reported: "Жалоба отправлена. Спасибо.",
      reportFailed: "Не удалось отправить жалобу",
      blocked: "Заблокировано.",
      blockFailed: "Не удалось заблокировать",
      reasons: {
        spam: "Спам", abuse: "Оскорбление", harassment: "Домогательство", hate: "Ненависть",
        nsfw: "NSFW", scam: "Мошенничество", impersonation: "Выдача за другого", other: "Другое",
      },
    },
    bar: {
      save: "Сохранить", saved: "Сохранено", comments: "Комментарии",
      likeError: "Не удалось обновить лайк", saveError: "Не удалось обновить сохранение",
    },
    comment: {
      post: "Опубликовать", postError: "Не удалось опубликовать", removed: "[удалено]", you: "вы",
      reply: "Ответить", hide: "Скрыть", viewOne: "Показать {n} ответ", viewMany: "Показать ответы: {n}",
      delete: "Удалить", loadingReplies: "Загрузка ответов…", replyPlaceholder: "Напишите ответ…",
      heading: "Комментарии", topPlaceholder: "Поделитесь мыслями об этой Территории…",
      signin: "Войдите, чтобы присоединиться к обсуждению →", loading: "Загрузка комментариев…",
      empty: "Пока нет комментариев. Будьте первым.", loadingMore: "Загрузка…", loadMore: "Загрузить ещё",
    },
    creator: {
      signinPre: "Войдите", signinPost: "чтобы увидеть свой профиль.",
      none: "Создатель не указан.", loading: "Загрузка профиля…", unavailable: "Профиль недоступен.",
      followers: "Подписчики", following: "Подписки", likes: "Лайки", comments: "Комментарии",
      territories: "Территории", published: "Опубликовано",
      gotoFeed: "Перейти к вашей ленте →", recentActivity: "Недавняя активность",
    },
    feed: {
      title: "Социальное", yourProfile: "Ваш профиль →",
      following: "Подписки", discover: "Обзор",
      followingSignin: "Войдите, чтобы видеть создателей, на которых вы подписаны →",
      loading: "Загрузка ленты…", unavailable: "Лента недоступна.",
      emptyFollowing: "В вашей ленте тихо. Подпишитесь на создателей, чтобы видеть здесь их новые Территории и работы.",
      emptyDiscover: "Пока нечего открывать — новые опубликованные Территории появятся здесь.",
      loadingMore: "Загрузка…", loadMore: "Загрузить ещё",
      titlePublication: "Опубликовал Территорию",
      titleArtworkNamed: "Опубликовал работу «{title}»",
      titleArtwork: "Опубликовал работу",
      titleAcquiredParcel: "Приобрёл парцеллу #{id}",
      titleAcquired: "Приобрёл новую Территорию",
    },
    handle: {
      heading: "Ваш социальный профиль", handleLabel: "Имя пользователя", handlePlaceholder: "ваше_имя",
      save: "Сохранить", handleSaved: "Имя пользователя сохранено.", handleError: "Не удалось сохранить имя пользователя",
      handleHint: "3–24 символа · буквы, цифры, подчёркивание · можно менять раз в 30 дней.",
      linksLabel: "Ссылки", linkLabelPlaceholder: "Метка", addLink: "+ Добавить ссылку",
      saveLinks: "Сохранить ссылки", linksSaved: "Ссылки сохранены.", linksError: "Не удалось сохранить ссылки",
    },
  },
  legal: {
    navAria: "Навигация по юридическим документам",
  },
  editor: {
    pixel: {
      title: "Pixel Studio",
      deleteTitle: "Удалить этот пиксель-арт",
      delete: "Удалить",
      closeTitle: "Закрыть студию",
      startingPoint: "Отправная точка",
      startingPointBody: "Мы превратили ваше изображение в пиксели, чтобы дать вам основу. Теперь сделайте его своим…",
      pencil: "Карандаш", eraser: "Ластик", fill: "Заливка", pick: "Пипетка",
      undo: "Отменить", redo: "Повторить", clear: "Очистить", grid: "Сетка",
      importOpen: "Импортировать изображение → Пиксель",
      brush: "Кисть", zoom: "Масштаб",
      zoomOutTitle: "Масштаб − (меньше ячейки)", zoomInTitle: "Масштаб + (больше ячейки)",
      cellsPainted: "Закрашено ячеек:",
      paletteActive: "Активная палитра", paletteActiveNote: "· импортированное изображение / рисунок",
      add: "+ Добавить", recent: "Недавние",
      paletteBase: "Базовая палитра", paletteBaseNote: "· стандартные цвета THE GRID",
      saving: "Сохранение…", saveArtworkCanvas: "Сохранить работу + холст",
      unsaved: "Не сохранено", saved: "Сохранено", close: "Закрыть",
      pixelizeTitle: "Пикселизировать изображение", cancel: "Отмена",
      resultingGrid: "Результирующая сетка:", colorsLabel: "цветов:",
      resolution: "Разрешение (длинная сторона)", fitMode: "Подгонка",
      fitContain: "Вместить", fitCover: "Заполнить", maxColors: "Макс. цветов",
      dithering: "Дизеринг", on: "ВКЛ", off: "ВЫКЛ",
      alphaThreshold: "Порог прозрачности ({v})", useAsBase: "Использовать как основу",
      unsavedTitle: "Несохранённые изменения",
      unsavedBody: "У вас есть изменения пиксель-арта, ещё не сохранённые на холсте. Что вы хотите сделать?",
      saveAndClose: "Сохранить и закрыть", discardClose: "Закрыть без сохранения",
    },
    voxel: {
      invalid: "Недопустимый маршрут 3D-редактора.",
      authRequired: "Войдите с помощью кошелька, чтобы редактировать эту 3D-сцену.",
      signIn: "Войти →",
      loading: "Загрузка 3D-редактора…",
      back: "Назад",
      empty: "Нет территории.",
      failedToLoad: "Не удалось загрузить",
      noFootprint: "У этой территории нет собственных парцелл для строительства.",
      flashCreateFirst: "Сначала создайте или выберите Работу",
      flashOutside: "За пределами вашей собственной области",
      flashCleared: "Активный элемент очищен",
      flashNoImage: "Не удалось прочитать изображение",
      flashBaseInside: "Основание должно оставаться внутри вашей территории",
      canvas: "Canvas",
      add: "Добавить", remove: "Удалить", cancelBase: "Отменить основание",
      currentColorTitle: "Текущий цвет (измените его в боковой панели)",
      undo: "Отменить", undoTitle: "Отменить (Ctrl+Z)",
      redo: "Повторить", redoTitle: "Повторить (Ctrl+Shift+Z)",
      clear: "Очистить", clearTitle: "Очистить активный элемент",
      resetView: "Сбросить вид",
      saving: "Сохранение…", saved: "Сохранено", save: "Сохранить",
      saveTitle: "Сохранить 3D-черновик", saveOverTitle: "Превышена ёмкость — удалите воксели для сохранения",
      publishTitle: "Публикация происходит на Canvas — она автоматически включает эту сохранённую 3D-сцену",
      publishLink: "Опубликовать на Canvas →",
      reload: "Перезагрузить",
      color: "Цвет", customColorTitle: "Свой цвет",
      workArts: "Работы", newBase: "+ Новое основание",
      budgetLabel: "Бюджет:", cellsUnit: "ячеек",
      noWorkArts: "Пока нет работ.",
      activePiece: "Активный элемент", rotate: "Повернуть", rotationHint: "Сбросьте поворот до 0°, чтобы редактировать воксели.",
      imageToVoxel: "Изображение → Воксель", depth: "Глубина", converting: "Конвертация…", chooseImage: "Выбрать изображение…",
      conversionHelp: "Конвертация помогает начать с простой экструзии. Вы можете доработать результат воксель за вокселем.",
      fallback: "3D-редактирование требует WebGL, который это устройство не смогло запустить. Ваш 3D-черновик в безопасности — попробуйте настольный браузер с аппаратным ускорением.",
      defineTitle: "Определите основание — перетащите по сетке",
      defineBody: "Перетащите прямоугольник по полу, чтобы задать размер элемента, затем отпустите, чтобы создать его.",
      sizeLabel: "Размер", tooBig: "· слишком большой",
      noCapacityTitle: "Нет свободной 3D-ёмкости",
      noCapacityBody: "Вы пока не можете размещать блоки на этой территории. Бесплатный 3D-подарок (10 000+ вокселей) предоставляется только кошельку, который купил парцеллу на первичной продаже и всё ещё владеет ею. Парцеллы, которые были заявлены/сминчены или куплены со вторых рук, не получают ничего.",
      hintNewBase: "Нажмите «+ Новое основание», затем перетащите по сетке, чтобы задать размер элемента.",
      howToBuild: "Как строить",
      step1: "Нажмите + Новое основание, затем перетащите по сетке, чтобы задать размер элемента",
      step2: "Левый клик по полу / грани блока, чтобы размещать блоки",
      step3: "Правый клик по блоку, чтобы удалить его",
      mouse: "Мышь", showControls: "Показать управление и как строить", hide: "Скрыть",
      leftClick: "Левый клик", rightClick: "Правый клик", ctrlLeft: "Ctrl + левый", ctrlRight: "Ctrl + правый", scroll: "Прокрутка",
      drawBase: "Рисовать основание", placeBlock: "Разместить блок", removeBlock: "Удалить блок", orbit: "Облёт вокруг клика", pan: "Переместить вид", zoomInOut: "Приблизить / отдалить",
      capacity3d: "3D-ёмкость", overCapacity: "Превышена ёмкость",
    },
    templates: {
      title: "Шаблоны Canvas",
      curatedStarts: "6 отобранных стартов",
      close: "Закрыть шаблоны",
      apply: "Применить шаблон",
      previewAria: "Предпросмотр макета {name}",
      replaceTitle: "Заменить текущий черновик?",
      replaceBody: "Применение {name} заменит содержимое вашего текущего черновика ({count} {unit}). Ваша опубликованная территория не затрагивается, пока вы не сохраните и не опубликуете. Это действие можно отменить только через Отмену.",
      elementOne: "элемент",
      elementOther: "элементов",
      cancel: "Отмена",
      replaceDraft: "Заменить черновик",
      catalog: {
        creator: { name: "Создатель / Личный бренд", useCase: "Личная идентичность", tagline: "Смелая центрированная идентичность — имя, роль, био, соцсети и один призыв к действию.", tag0: "Идентичность", tag1: "Био", tag2: "Соцсети" },
        retail: { name: "Ритейл / Витрина", useCase: "Небольшой бренд и магазин", tagline: "Заголовок бренда над ритмичной полкой товаров с чётким действием «посетить магазин».", tag0: "Товары", tag1: "Полка", tag2: "Ссылка магазина" },
        gallery: { name: "Художник / Галерея", useCase: "Работа на первом месте", tagline: "Одна доминирующая рамка с тихим высказыванием — работа ведёт, слова следуют.", tag0: "Работа", tag1: "Высказывание", tag2: "Минимализм" },
        music: { name: "Музыка / Событие", useCase: "Релиз и живое событие", tagline: "Энергичный заголовок, дата и место, и прямое действие билеты / стрим.", tag0: "Событие", tag1: "Дата", tag2: "Билеты" },
        product: { name: "Продукт / Запуск технологии", useCase: "Лендинг запуска", tagline: "Современная страница запуска — заголовок, поддерживающая строка, три блока функций и CTA.", tag0: "Запуск", tag1: "Функции", tag2: "CTA" },
        minimal: { name: "Минимальная роскошь", useCase: "Высококлассный минимализм", tagline: "Сдержанная типографика и щедрое пространство — одно слово, одна строка, одно действие.", tag0: "Роскошь", tag1: "Белое пространство", tag2: "Сдержанность" },
      },
    },
    error: {
      title: "В холсте произошла ошибка",
      body: "Редактор восстановился вместо того, чтобы стать чёрным. Несохранённые изменения с момента последнего сохранения не были записаны на сервер. Попробуйте закрыть, чтобы продолжить, или перезагрузите редактор для чистого состояния.",
      dismiss: "Закрыть",
      reload: "Перезагрузить редактор",
    },
    canvas: {
      invalid: "Недопустимый маршрут холста.",
      authRequired: "Войдите с помощью кошелька, чтобы редактировать этот Холст.",
      signIn: "Войти →",
      loading: "Загрузка холста…",
      empty: "Нет холста.",
      failedToLoad: "Не удалось загрузить",
      back: "Назад",
      close: "Закрыть",
      cancel: "Отмена",
      exitConfirm: "У вас есть несохранённые изменения. Выйти без сохранения?",
      flash: {
        saved3d: "Позиция 3D сохранена",
        territoryChanged3d: "Территория изменилась — перезагрузите редактор",
        error3d: "3D: {code}",
        rotateOutside: "Поворот вышел бы за пределы территории",
      },
      save: {
        territoryChanged: "Территория изменилась — перезагрузите редактор",
      },
      toolbar: {
        territories: "Территории",
        undo: "Отменить",
        redo: "Повторить",
        fit: "Вписать территорию",
        templates: "Шаблоны",
        templatesTitle: "Начните с премиум-шаблона",
        templatesDisabledTitle: "Шаблонам нужна собственная территория",
        mediaLibrary: "Медиатека",
        mediaLibraryTitle: "Медиатека — загружайте и просматривайте, не покидая редактор",
        artistProfile: "Профиль художника",
        artistProfileTitle: "Откройте свой профиль художника",
        editor3d: "3D-редактор",
        editor3dTitle: "Откройте 3D-воксельный редактор для этой территории",
        save: "Сохранить",
        saving: "Сохранение…",
        saveTitle: "Сохранить холст",
        saveOverTitle: "Превышена ёмкость — уменьшите использование GP, чтобы сохранить",
        freeze: "Заморозить",
        freezeTitle: "Заморозить эту работу Pixel Studio",
        freezeBlockedTitle: "Сохраните холст перед заморозкой",
      },
      tools: {
        pixelArt: "Pixel Art",
        new: "НОВОЕ",
        text: "Текст",
        interactive: "Интерактив",
        media: "Медиа",
        shapes: "Фигуры",
      },
      pixelDraw: {
        banner: "Нарисуйте прямоугольник на вашей территории",
      },
      pixelSize: {
        title: "Новая Pixel Art",
        body: "Выберите размер холста — 1 ячейка = 1 участок. Пустые ячейки остаются прозрачными.",
        custom: "Свой — рисуйте на территории",
      },
      mobileReadonly: "На этом устройстве только просмотр / осмотр. Для редактирования нужен экран побольше.",
      gp: {
        used: "Использовано",
        available: "Доступно {n} GP",
        overCapacity: "Превышена ёмкость",
      },
      status: {
        saved: "Сохранено",
        unsavedChanges: "Несохранённые изменения",
        saving: "Сохранение…",
        error: "Ошибка",
        showError: "Показать полную ошибку",
      },
      inspector: {
        territoryTiers: "Уровни территории",
        globalStyle: "Глобальный стиль",
        background: "Фон",
        bgColor: "Цвет фона",
        perimeter: "Периметр",
        perimeterGlow: "Свечение периметра",
        opacity: "Непрозрачность {v}%",
        glow: "Свечение",
        glowColor: "Цвет свечения",
        text: "Текст",
        label: "Подпись",
        subtitleOptional: "Подзаголовок (необязательно)",
        urlHttps: "URL (https)",
        previewOpen: "Предпросмотр / Открыть ↗",
        fill: "Заливка",
        lineColor: "Цвет линии",
        fit: "Вписывание",
        pixelArt: "Pixel Art",
        editPixels: "Редактировать пиксели",
        title: "Заголовок",
        bgPreview: "Предпросмотр фона",
        changeImage: "Сменить изображение",
        addImage: "+ Добавить изображение",
        selectedGp: "GP {used} / {max} макс",
      },
      controls: {
        preset: "Пресет",
        layout: "Макет",
        direction: "Направление",
        columns: "Столбцы {v}",
        align: "Выравнивание",
        gap: "Отступ {v}",
        iconSize: "Размер иконки {v}",
        labelOptional: "Подпись (необязательно)",
        labelColor: "Цвет подписи",
        brandColors: "Фирменные цвета",
        iconColor: "Цвет иконки",
        backgroundChip: "Фоновый чип",
        bgColor: "Цвет фона",
        border: "Рамка",
        borderColor: "Цвет рамки",
        radius: "Радиус",
        padding: "Внутренний отступ {v}",
        hover: "Наведение",
        font: "Шрифт",
        color: "Цвет",
        textSize: "Размер текста {v}",
        style: "Стиль",
        subtitleColor: "Цвет подзаголовка",
        underline: "Подчёркивать подпись",
        icon: "Иконка",
      },
      social: {
        links: "Ссылки ({n}/5)",
        removeLink: "Удалить ссылку",
        addLink: "+ Добавить ссылку",
        showLabels: "Показывать подписи",
        labelFont: "Шрифт подписи",
        labelSize: "Размер подписи {v}",
      },
      contacts: {
        heading: "Контакты ({n}/10)",
        removeContact: "Удалить контакт",
        addContact: "+ Добавить контакт",
        show: "Показать",
        value: "Значение",
        dataColor: "Цвет данных",
        kind: { EMAIL: "Эл. почта", PHONE: "Телефон", WHATSAPP: "WhatsApp", WEBSITE: "Веб-сайт", MAP: "Адрес" },
        placeholder: { EMAIL: "name@example.com", PHONE: "+7 495 000 1234", WHATSAPP: "+7 495 000 1234", WEBSITE: "https://example.com", MAP: "ул. Главная 1, Город" },
      },
      layers: {
        title: "Слои",
        empty: "Пока нет модулей.",
        front: "На передний план",
        forward: "Вперёд",
        backward: "Назад",
        back: "На задний план",
        hide: "Скрыть",
        lock: "Заблокировать",
      },
      mediaPanel: {
        title: "Медиатека",
        working: "Выполняется…",
        upload: "Загрузить",
        hint: "Изображение 10 · GIF 20 (10с) · PDF 25 · Видео 250 МиБ · Библиотека 2 ГиБ. Загрузки сразу появляются в селекторах добавления медиа.",
        loading: "Загрузка библиотеки…",
        empty: "Пока нет медиа. Загрузите изображение, GIF, PDF или видео, чтобы начать библиотеку.",
        loadMore: "Загрузить ещё",
        deleteAria: "Удалить ресурс",
      },
      mediaPicker: {
        choose: "Выберите {kind} из медиатеки",
        empty: "Нет ресурсов {kind}. Сначала загрузите в медиатеке панели.",
      },
      mediaKind: { image: "изображение", gif: "GIF", video: "видео", pdf: "PDF" },
      errorModal: {
        saveFailed: "Не удалось сохранить",
        gotIt: "Понятно",
      },
      tier: { STANDARD: "Standard", PREMIUM: "Premium", VIP_CORE: "VIP Core", RESERVE: "Резерв", GRID_ZERO: "GRID ZERO" },
      enum: {
        module: { TITLE: "Заголовок", TAGLINE: "Слоган", DESCRIPTION: "Описание", LINK: "Ссылка", SOCIAL: "Соцсети", CONTACTS: "Контакты", IMAGE: "Изображение", GIF: "GIF", VIDEO: "Видео", PDF: "PDF", PIXEL_ART: "Pixel Art", SHAPE: "Фигура" },
        shape: { RECTANGLE: "Прямоугольник", ROUNDED_RECTANGLE: "Скруглённый прямоугольник", ELLIPSE: "Эллипс", LINE: "Линия" },
        bgMode: { NEUTRAL: "Нейтральный", SOLID_COLOR: "Сплошной цвет" },
        glow: { OFF: "Выкл", LOW: "Низкое", MEDIUM: "Среднее", HIGH: "Высокое" },
        direction: { HORIZONTAL: "Горизонтально", VERTICAL: "Вертикально", GRID: "Сетка" },
        align: { START: "Начало", CENTER: "Центр", END: "Конец" },
        textAlign: { LEFT: "По левому краю", CENTER: "По центру", RIGHT: "По правому краю", JUSTIFY: "По ширине" },
        radius: { SQUARE: "Прямые углы", SLIGHT: "Слегка", ROUNDED: "Скруглённый", PILL: "Пилюля" },
        hover: { NONE: "Нет", LIFT: "Подъём", GLOW: "Свечение", SCALE: "Масштаб" },
        fit: { COVER: "Заполнить", CONTAIN: "Вписать" },
        contactsDisplay: { ICON: "Иконка", ICON_LABEL: "Иконка + подпись", ICON_DATA: "Иконка + данные", BUTTON: "Кнопка" },
        linkIcon: { NONE: "Нет", ARROW: "Стрелка", FAVICON: "Фавикон" },
        socialPreset: { ICONS_ONLY: "Только иконки", MINIMAL: "Минимал", BUTTONS: "Кнопки", CARDS: "Карточки" },
        contactsPreset: { ICONS_ONLY: "Только иконки", BUSINESS: "Бизнес", MINIMAL: "Минимал" },
        linkPreset: { TEXT: "Текст", BUTTON: "Кнопка", OUTLINE: "Контур", CARD: "Карточка" },
      },
    },
  },
};

export default ru;
